import type {
  ActivityLogListResponse,
  ActivityLogStats,
  AIExceptionRow,
  AIExceptionWritePayload,
  AIInstructionRow,
  AIInstructionWritePayload,
  AIKnowledgeBaseCreatePayload,
  AIKnowledgeBaseRow,
  AIKnowledgeBaseUpdatePayload,
  AILinkInventoryResponse,
  AILinkReplacePayload,
  AILinkReplaceResponse,
  AIAuditLogsResponse,
  AnomalyTicketsResponse,
  BookmarksListResponse,
  ClearBookmarksResponse,
  ColleaguesTodayResponse,
  CustomerAttachmentItem,
  CurrentShiftResponse,
  OnShiftUserIdsResponse,
  ShiftStatusBadgesResponse,
  CustomerRow,
  DebugAiRequestsResponse,
  DebugAiStuckResponse,
  DebugAiTicketsResponse,
  DebugAutoResolveBlocksResponse,
  DebugAiQueueBlocksResponse,
  DebugClearAiQueueBlocksResponse,
  DebugClearAllAiQueueBlocksResponse,
  DebugClearBatchAiQueueBlocksResponse,
  DebugMozgobotPipelineReportResponse,
  DebugPendingHistoryResponse,
  DebugPurgeAiQueueResponse,
  DebugDbConnectionsResponse,
  FailedDeliveriesResponse,
  DebugShiftBreakRepairResponse,
  DebugShiftBreakScanResponse,
  DebugSlowFirstResponseResponse,
  EndBreakResponse,
  EmergencyModeHistoryRow,
  EmergencyModeHistoryPage,
  EmergencyIncidentHistoryPage,
  EmergencyCustomTemplate,
  EmergencyModeWithStats,
  EmergencyDisableStatus,
  InstallerRow,
  InstallerUpdatePayload,
  InstallerUploadResponse,
  LoginResponse,
  MattermostBotTestResponse,
  MeUser,
  MyPermissionsResponse,
  RolePermissionCreatePayload,
  RolePermissionItem,
  RolePermissionUpdatePayload,
  OpenAIResourcesResponse,
  OperatorProjectRoutingItem,
  OperatorProjectRoutingResponse,
  AnalyticsDashboardStats,
  AiOperationsAnalyticsResponse,
  OperatorTicketsBlockResponse,
  OperatorsByProjectSummaryResponse,
  OperatorsDetailedResponse,
  OperatorDetailedMeResponse,
  OperatorOverviewRow,
  OperatorsKtuResponse,
  ProductReviewReceivedByCustomersResponse,
  ProductReviewStatsByCustomerResponse,
  ProductReviewStatsResponse,
  ReviewStatsResponse,
  RetryFailedDeliveryResponse,
  ReviewsByOperatorSummaryResponse,
  TagsStatsResponse,
  TicketHandleTimeoutsResponse,
  TicketSdAdminApiAction,
  TicketSdAdminApiActionResponse,
  MeDoneByDayResponse,
  ProjectAISettingsResponse,
  ProjectAIUpdatePayload,
  ProjectAIReleaseTicketsResponse,
  ProjectAnomalySettingsPayload,
  ProjectAnomalySettingsRow,
  ProjectSpamSettings,
  SpamBlockedSenderRow,
  SpamIdentifierType,
  SpamPage,
  SpamSource,
  SpamTicketRow,
  TicketSpamState,
  ProjectCreatePayload,
  ProjectCustomerFieldRow,
  ProjectDetailResponse,
  ProjectRow,
  ProjectTagRow,
  ProjectTemplateRow,
  ProjectQuickSettingsPayload,
  WorkspaceQuickSettingsPayload,
  ProjectUpdatePayload,
  QualityCriterion,
  QualityAISettings,
  ExportAISettings,
  ExportAIJob,
  ExportTicketsPreview,
  QualityHistoryResponse,
  QualityIncorrectResponseRow,
  QualityIncorrectResponsesResponse,
  QualityCheckItemRow,
  QualityReportResponse,
  QualitySessionRow,
  QualitySessionCreatePayload,
  QualitySessionPreview,
  QualitySettingsResponse,
  QualityTargetRow,
  ChannelCreatePayload,
  ChannelDetail,
  ChannelRow,
  ChannelUpdatePayload,
  TagRuleRow,
  TagRuleClassificationTestResponse,
  LoadTestProjectOption,
  LoadTestProjectConfig,
  LoadTestStatusResponse,
  LoadTestStartResponse,
  LoadTestErrorsResponse,
  ProjectUserIdentifierRow,
  ProjectUserIdentifiersListResponse,
  SavedFilterCreatePayload,
  SavedFilterRow,
  SavedFilterUpdatePayload,
  SuggestAIInstructionFromTicketResponse,
  VLLMResourcesResponse,
  VLLMGatewayModel,
  VLLMSyncResponse,
  TicketCountsResponse,
  TicketDetailResponse,
  SimilarClosedTicketsResponse,
  ParallelCustomerTicketsResponse,
  TicketGetResponse,
  TicketListItem,
  MacroRow,
  SupportKnowledgeArticleRow,
  SupportKnowledgeArticleWritePayload,
  SupportKnowledgeAttachmentRow,
  SupportKnowledgeAcknowledgeResponse,
  SupportKnowledgePendingChangesResponse,
  SupportKnowledgeReadStatsResponse,
  SupportKnowledgeSearchRow,
  SupportKnowledgeSimilarResponse,
  SupportKnowledgeTagRow,
  SupportKnowledgeTagRuleRow,
  SupportKnowledgeTagRuleWritePayload,
  SupportKnowledgeTagWritePayload,
  SupportKnowledgeTrainingAttemptRow,
  SupportKnowledgeTrainingPendingResponse,
  SupportKnowledgeTrainingQuestionPayload,
  SupportKnowledgeTrainingQuestionRow,
  SupportKnowledgeTrainingStatsResponse,
  SupportKnowledgeVariableDefinitionRow,
  SupportKnowledgeVariableWritePayload,
  SupportKnowledgeViewFinishResponse,
  SupportKnowledgeImageUploadResponse,
  ReplyFavoritesResponse,
  ReplyFavoritesUpdatePayload,
  ReviewsListResponse,
  TicketListResponse,
  TicketTimelineResponse,
  TicketAnomalyRow,
  TicketMessagesPageResponse,
  TicketProductReviewStatusResponse,
  TicketReviewStatusResponse,
  TicketViewerRow,
  TicketsBulkReplyPayload,
  TriggerCreatePayload,
  TriggerRow,
  TriggerUpdatePayload,
  UserProfileUpdatePayload,
  WorkspaceRow,
  WorkspaceSlaRulesResponse,
  WorkspaceUpdatePayload,
  ScheduleStaffingAnalysisRow,
  ScheduleStaffingSectionKey,
  ScheduleStaffingSectionResponse,
  WorkspaceRolePermissionsResponse,
  WorkspaceUserRow,
  ScheduleUserRow,
  ScheduleMonthApiResponse,
  ScheduleBulkDeleteRangeResponse,
  ScheduleRangeSummaryResponse,
  ScheduleResponseRow,
  ShiftsMonthResponse,
  ScheduleWorkInterval,
} from "@/types/api";
import { storage } from "@/lib/storage";
import { formatUserApiError } from "@/lib/api-error-messages";

export {
  DEFAULT_ERROR_NOTIFY_MESSAGE,
  formatUserApiError,
} from "@/lib/api-error-messages";

/**
 * REST uses relative `/api/v1` only, without baking public API origin into the bundle.
 * Прод: nginx тот же origin → `/api/...` на бэкенд. Dev: Vite проксирует `/api` на `VITE_API_URL`.
 */
const API_URL = "/api/v1";

function apiUrl(path: string): string {
  const root = API_URL.replace(/\/$/, "");
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${root}${p}`;
}

function apiDetail(detail: unknown): string {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) =>
        typeof e === "object" && e && "msg" in e
          ? String((e as { msg: string }).msg)
          : JSON.stringify(e),
      )
      .join("; ");
  }
  return "Ошибка запроса";
}

async function parseJson<T>(res: Response): Promise<T> {
  const text = await res.text();
  if (!text) {
    if (!res.ok) {
      throw new Error(formatUserApiError(res.status, res.statusText || ""));
    }
    return {} as T;
  }
  try {
    return JSON.parse(text) as T;
  } catch {
    throw new Error("Некорректный ответ сервера");
  }
}

export class ApiError extends Error {
  status: number;
  detail?: unknown;
  constructor(status: number, message: string, detail?: unknown) {
    super(message);
    this.status = status;
    this.detail = detail;
    this.name = "ApiError";
  }
}

/** Без таймаута fetch может «висеть» бесконечно (прокси на тот же порт, недоступный бэкенд) — тогда AuthProvider не выставляет ready. */
const FETCH_TIMEOUT_MS = 45_000;

/** Долгие вызовы (LLM): бэкенд до ~180 с + сеть; прокси Vite см. vite.config proxyTimeout. */
const FETCH_TIMEOUT_LLM_MS = 300_000;

/** Тяжёлые отчёты на больших периодах: backend кэширует, но первый прогрев может быть дольше обычного fetch. */
const FETCH_TIMEOUT_ANALYTICS_MS = 120_000;

/** Выгрузки обращений без лимита строк: файл приходит потоком и может качаться несколько минут. */
const FETCH_TIMEOUT_EXPORT_MS = 30 * 60_000;

function abortAfter(ms: number): AbortSignal {
  if (
    typeof AbortSignal !== "undefined" &&
    typeof (AbortSignal as { timeout?: (n: number) => AbortSignal }).timeout ===
      "function"
  ) {
    return (AbortSignal as { timeout: (n: number) => AbortSignal }).timeout(ms);
  }
  const c = new AbortController();
  globalThis.setTimeout(() => c.abort(), ms);
  return c.signal;
}

function mergeAbortSignals(a: AbortSignal, b: AbortSignal): AbortSignal {
  if (
    typeof AbortSignal !== "undefined" &&
    typeof (AbortSignal as { any?: (s: AbortSignal[]) => AbortSignal }).any ===
      "function"
  ) {
    return (AbortSignal as { any: (s: AbortSignal[]) => AbortSignal }).any([
      a,
      b,
    ]);
  }
  const c = new AbortController();
  const forward = () => c.abort();
  if (a.aborted || b.aborted) {
    c.abort();
    return c.signal;
  }
  a.addEventListener("abort", forward, { once: true });
  b.addEventListener("abort", forward, { once: true });
  return c.signal;
}

async function rawFetch(
  path: string,
  init: RequestInit & { _retry?: boolean; _fetchTimeoutMs?: number } = {},
): Promise<Response> {
  const { _fetchTimeoutMs, ...restInit } = init;
  const headers = new Headers(restInit.headers);
  if (
    !headers.has("Content-Type") &&
    restInit.body &&
    typeof restInit.body === "string"
  ) {
    headers.set("Content-Type", "application/json");
  }
  const token = storage.accessToken();
  if (token) headers.set("Authorization", `Bearer ${token}`);

  const timeoutMs =
    typeof _fetchTimeoutMs === "number" && _fetchTimeoutMs > 0
      ? _fetchTimeoutMs
      : FETCH_TIMEOUT_MS;
  const timeoutSig = abortAfter(timeoutMs);
  const signal = restInit.signal
    ? mergeAbortSignals(restInit.signal, timeoutSig)
    : timeoutSig;

  try {
    return await fetch(apiUrl(path), { ...restInit, headers, signal });
  } catch (e) {
    if (e instanceof ApiError) throw e;
    // AbortSignal.timeout() rejects with "TimeoutError", a manual abort with "AbortError".
    const errorName = e instanceof Error || e instanceof DOMException ? e.name : "";
    const aborted = errorName === "AbortError" || errorName === "TimeoutError";
    if (aborted) {
      throw new ApiError(
        408,
        "Превышено время ожидания ответа сервера. Проверьте, что бэкенд запущен и VITE_API_URL не указывает на порт фронта.",
      );
    }
    if (e instanceof TypeError) {
      throw new ApiError(
        503,
        "Нет соединения с API. Убедитесь, что бэкенд доступен (например http://127.0.0.1:8000) и в .env задан верный VITE_API_URL.",
      );
    }
    throw e;
  }
}

/** Одновременные 401 на нескольких запросах — один refresh, остальные ждут тот же Promise. */
let refreshInFlight: Promise<boolean> | null = null;

async function refreshTokens(): Promise<boolean> {
  if (refreshInFlight) return refreshInFlight;
  refreshInFlight = (async () => {
    try {
      const rt = storage.refreshToken();
      if (!rt) return false;
      const res = await rawFetch("/auth/refresh", {
        method: "POST",
        body: JSON.stringify({ refresh_token: rt }),
      });
      if (!res.ok) return false;
      const data = await parseJson<LoginResponse>(res);
      storage.setAccessToken(data.access_token);
      storage.setRefreshToken(data.refresh_token);
      return true;
    } finally {
      refreshInFlight = null;
    }
  })();
  return refreshInFlight;
}

export async function apiFetch<T>(
  path: string,
  init: RequestInit & { _retry?: boolean; _fetchTimeoutMs?: number } = {},
): Promise<T> {
  let res = await rawFetch(path, init);

  if (
    res.status === 401 &&
    !path.includes("/auth/refresh") &&
    !path.includes("/auth/login")
  ) {
    const retried = init as RequestInit & { _retry?: boolean };
    if (!retried._retry) {
      const ok = await refreshTokens();
      if (ok) {
        res = await rawFetch(path, { ...init, _retry: true });
      }
    }
  }

  const data = await parseJson<{ detail?: unknown } & T>(res);
  if (!res.ok) {
    if (res.status === 401 && !path.includes("/auth/login")) {
      storage.clearSession();
    }
    throw new ApiError(
      res.status,
      formatUserApiError(
        res.status,
        apiDetail(data.detail ?? res.statusText ?? ""),
      ),
      data.detail,
    );
  }
  return data as T;
}

/** Дедуп параллельных /tickets/counts + короткий TTL (сайдбар + список тикетов). */
let ticketCountsInFlight: Promise<TicketCountsResponse> | null = null;
let ticketCountsCached: { at: number; value: TicketCountsResponse } | null =
  null;
const TICKET_COUNTS_TTL_MS = 12_000;

export function invalidateTicketCountsCache(): void {
  ticketCountsCached = null;
  ticketCountsInFlight = null;
}

function coalesceTicketCounts(
  fetcher: () => Promise<TicketCountsResponse>,
): Promise<TicketCountsResponse> {
  const now = Date.now();
  if (
    ticketCountsCached &&
    now - ticketCountsCached.at < TICKET_COUNTS_TTL_MS
  ) {
    return Promise.resolve(ticketCountsCached.value);
  }
  if (ticketCountsInFlight) return ticketCountsInFlight;
  ticketCountsInFlight = fetcher()
    .then((value) => {
      ticketCountsCached = { at: Date.now(), value };
      return value;
    })
    .finally(() => {
      ticketCountsInFlight = null;
    });
  return ticketCountsInFlight;
}

type ApiCacheEntry<T> = { at: number; value: T };

const analyticsResponseCache = new Map<string, ApiCacheEntry<unknown>>();
const analyticsInFlight = new Map<string, Promise<unknown>>();
const ANALYTICS_CLIENT_CACHE_TTL_MS = 30_000;
const ANALYTICS_CLIENT_CACHE_MAX_ENTRIES = 120;

export function invalidateAnalyticsResponseCache(): void {
  analyticsResponseCache.clear();
  analyticsInFlight.clear();
}

function cachedApiFetch<T>(
  path: string,
  init: RequestInit & { _retry?: boolean; _fetchTimeoutMs?: number } = {},
  ttlMs = ANALYTICS_CLIENT_CACHE_TTL_MS,
): Promise<T> {
  const method = String(init.method || "GET").toUpperCase();
  if (method !== "GET") return apiFetch<T>(path, init);

  const key = `${method}:${path}`;
  const now = Date.now();
  const cached = analyticsResponseCache.get(key);
  if (cached && now - cached.at < ttlMs) {
    return Promise.resolve(cached.value as T);
  }

  const existing = analyticsInFlight.get(key);
  if (existing) return existing as Promise<T>;

  const promise = apiFetch<T>(path, init)
    .then((value) => {
      analyticsResponseCache.set(key, { at: Date.now(), value });
      if (analyticsResponseCache.size > ANALYTICS_CLIENT_CACHE_MAX_ENTRIES) {
        const oldestKey = analyticsResponseCache.keys().next().value;
        if (oldestKey) analyticsResponseCache.delete(oldestKey);
      }
      return value;
    })
    .finally(() => {
      analyticsInFlight.delete(key);
    });
  analyticsInFlight.set(key, promise);
  return promise;
}

/** Бинарный ответ (экспорт CSV и т.п.) с тем же refresh по 401. */
export async function apiFetchBlob(
  path: string,
  init: RequestInit & { _fetchTimeoutMs?: number } = {},
): Promise<Blob> {
  let res = await rawFetch(path, init);

  if (
    res.status === 401 &&
    !path.includes("/auth/refresh") &&
    !path.includes("/auth/login")
  ) {
    const retried = init as RequestInit & { _retry?: boolean };
    if (!retried._retry) {
      const ok = await refreshTokens();
      if (ok) {
        res = await rawFetch(path, { ...init, _retry: true });
      }
    }
  }

  if (!res.ok) {
    if (res.status === 401 && !path.includes("/auth/login")) {
      storage.clearSession();
    }
    const text = await res.text();
    try {
      const j = JSON.parse(text) as { detail?: unknown };
      throw new ApiError(
        res.status,
        formatUserApiError(res.status, apiDetail(j.detail ?? text)),
        j.detail,
      );
    } catch (e) {
      if (e instanceof ApiError) throw e;
      throw new ApiError(
        res.status,
        formatUserApiError(res.status, text || res.statusText || ""),
      );
    }
  }
  return res.blob();
}

export const api = {
  login(body: { email: string; password: string }) {
    return apiFetch<LoginResponse>("/auth/login", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  me() {
    return apiFetch<MeUser>("/users/me");
  },

  updateMyProfile(body: UserProfileUpdatePayload) {
    return apiFetch<MeUser>("/users/me/profile", {
      method: "PUT",
      body: JSON.stringify(body),
    });
  },

  changeMyPassword(body: { current_password: string; new_password: string }) {
    return apiFetch<{ message?: string }>("/users/me/change-password", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  uploadAvatar(file: File) {
    const fd = new FormData();
    fd.append("file", file);
    return apiFetch<{ avatar_url?: string; message?: string }>(
      "/users/me/avatar",
      {
        method: "POST",
        body: fd,
      },
    );
  },

  tickets(params: Record<string, string | number | boolean | undefined>) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined) continue;
      q.set(k, String(v));
    }
    return apiFetch<TicketListResponse>(`/tickets/?${q.toString()}`);
  },

  /** Сообщения обращения (пагинация как в classic; max limit=200 на бэкенде) */
  ticketMessages(ticketId: string, opts?: { limit?: number; offset?: number }) {
    const q = new URLSearchParams();
    q.set("limit", String(opts?.limit ?? 200));
    q.set("offset", String(opts?.offset ?? 0));
    return apiFetch<TicketMessagesPageResponse>(
      `/messages/ticket/${encodeURIComponent(ticketId)}?${q.toString()}`,
    );
  },

  ticketTimeline(ticketId: string) {
    return apiFetch<TicketTimelineResponse>(
      `/tickets/${encodeURIComponent(ticketId)}/timeline`,
    );
  },

  failedDeliveries(params?: { page?: number; page_size?: number }) {
    const q = new URLSearchParams();
    q.set("page", String(params?.page ?? 1));
    q.set("page_size", String(params?.page_size ?? 25));
    return apiFetch<FailedDeliveriesResponse>(
      `/messages/failed-deliveries?${q.toString()}`,
    );
  },

  retryFailedDelivery(messageId: string) {
    return apiFetch<RetryFailedDeliveryResponse>(
      `/messages/failed-deliveries/${encodeURIComponent(messageId)}/retry`,
      {
        method: "POST",
      },
    );
  },

  workspaceUsers(params?: { includeInactive?: boolean }) {
    if (!params?.includeInactive) {
      return apiFetch<WorkspaceUserRow[]>("/users/");
    }
    const q = new URLSearchParams();
    q.set("include_inactive", "true");
    return apiFetch<WorkspaceUserRow[]>(`/users/?${q.toString()}`);
  },

  userCreate(body: Record<string, unknown>) {
    return apiFetch<WorkspaceUserRow>("/users/", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  userUpdate(userId: string, body: Record<string, unknown>) {
    return apiFetch<WorkspaceUserRow>(`/users/${encodeURIComponent(userId)}`, {
      method: "PUT",
      body: JSON.stringify(body),
    });
  },

  userDelete(userId: string) {
    return apiFetch<unknown>(`/users/${encodeURIComponent(userId)}`, {
      method: "DELETE",
    });
  },

  operatorProjectRouting(userId: string) {
    return apiFetch<OperatorProjectRoutingResponse>(
      `/users/${encodeURIComponent(userId)}/project-routing`,
    );
  },

  operatorProjectRoutingUpdate(
    userId: string,
    items: OperatorProjectRoutingItem[],
  ) {
    return apiFetch<OperatorProjectRoutingResponse>(
      `/users/${encodeURIComponent(userId)}/project-routing`,
      {
        method: "PUT",
        body: JSON.stringify({
          items: items.map((item) => ({
            project_id: item.project_id,
            enabled: !!item.enabled,
            weight: Number(item.weight) || 0,
          })),
        }),
      },
    );
  },

  usersClearAvatars() {
    return apiFetch<{ updated?: number; message?: string }>(
      "/users/clear-avatars",
      { method: "POST" },
    );
  },

  workspaceRolePermissions() {
    return apiFetch<WorkspaceRolePermissionsResponse>(
      "/workspaces/me/role-permissions",
    );
  },

  projects() {
    return apiFetch<ProjectRow[]>("/projects/");
  },

  qualitySettings() {
    return apiFetch<QualitySettingsResponse>("/quality/settings");
  },

  qualitySettingsUpdate(body: {
    criteria?: QualityCriterion[];
    criteria_ai?: QualityCriterion[];
    default_sample_percent?: number;
    default_max_tickets?: number;
    min_closed_tickets?: number;
  }) {
    return apiFetch<QualitySettingsResponse>("/quality/settings", {
      method: "PUT",
      body: JSON.stringify(body),
    });
  },

  qualityCriteriaReset(target: "operators" | "bot") {
    return apiFetch<QualitySettingsResponse>(
      `/quality/settings/criteria/${encodeURIComponent(target)}/reset`,
      { method: "POST" },
    );
  },

  qualityCriteriaDefaultsUpdate(
    target: "operators" | "bot",
    criteria: QualityCriterion[],
  ) {
    return apiFetch<QualitySettingsResponse>(
      `/quality/settings/criteria/${encodeURIComponent(target)}/defaults`,
      {
        method: "PUT",
        body: JSON.stringify({ criteria }),
      },
    );
  },

  qualityAISettings() {
    return apiFetch<QualityAISettings>("/quality/ai-settings");
  },

  qualityAIModels() {
    return apiFetch<{ models: VLLMGatewayModel[] }>("/quality/ai-models");
  },

  qualityAISettingsUpdate(
    body: Omit<QualityAISettings, "assistant_sync" | "assistant_error">,
  ) {
    return apiFetch<QualityAISettings>("/quality/ai-settings", {
      method: "PUT",
      body: JSON.stringify(body),
    });
  },

  exportProjects() {
    return apiFetch<ProjectRow[]>("/exports/projects");
  },

  exportAISettings() {
    return apiFetch<ExportAISettings>("/exports/ai-settings");
  },

  exportAISettingsUpdate(body: ExportAISettings) {
    return apiFetch<ExportAISettings>("/exports/ai-settings", {
      method: "PUT",
      body: JSON.stringify(body),
    });
  },

  exportAIModels() {
    return apiFetch<{ models: VLLMGatewayModel[] }>("/exports/ai-models");
  },

  exportTicketsPreview(params: {
    project_ids?: string[];
    period_start: string;
    period_end: string;
    limit?: number;
  }) {
    const q = new URLSearchParams();
    for (const id of params.project_ids || []) q.append("project_ids", id);
    q.set("period_start", params.period_start);
    q.set("period_end", params.period_end);
    if (params.limit) q.set("limit", String(params.limit));
    return apiFetch<ExportTicketsPreview>(`/exports/tickets/preview?${q.toString()}`);
  },

  exportTickets(params: {
    project_ids?: string[];
    period_start: string;
    period_end: string;
    format?: "json" | "csv";
    limit?: number;
  }) {
    const q = new URLSearchParams();
    for (const id of params.project_ids || []) q.append("project_ids", id);
    q.set("period_start", params.period_start);
    q.set("period_end", params.period_end);
    q.set("format", params.format || "json");
    if (params.limit) q.set("limit", String(params.limit));
    return apiFetchBlob(`/exports/tickets?${q.toString()}`, {
      _fetchTimeoutMs: FETCH_TIMEOUT_EXPORT_MS,
    });
  },

  exportAIJobCreate(body: {
    project_ids: string[];
    period_start: string;
    period_end: string;
    prompt_appendix?: string;
  }) {
    return apiFetch<ExportAIJob>("/exports/ai-jobs", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  exportAIJobs() {
    return apiFetch<{ items: ExportAIJob[] }>("/exports/ai-jobs");
  },

  exportAIJob(jobId: string) {
    return apiFetch<ExportAIJob>(
      `/exports/ai-jobs/${encodeURIComponent(jobId)}`,
    );
  },

  exportAIJobCancel(jobId: string) {
    return apiFetch<ExportAIJob>(
      `/exports/ai-jobs/${encodeURIComponent(jobId)}/cancel`,
      { method: "POST" },
    );
  },

  qualityTargets() {
    return apiFetch<{ items: QualityTargetRow[] }>("/quality/targets");
  },

  qualitySessionPreview(body: QualitySessionCreatePayload) {
    return apiFetch<QualitySessionPreview>('/quality/sessions/preview', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

  qualitySessionCreate(body: QualitySessionCreatePayload) {
    return apiFetch<QualitySessionRow>("/quality/sessions", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  qualitySession(sessionId: string, signal?: AbortSignal) {
    return apiFetch<QualitySessionRow>(
      `/quality/sessions/${encodeURIComponent(sessionId)}`,
      { signal },
    );
  },

  qualityProgress(sessionId: string, signal?: AbortSignal) {
    return apiFetch<Pick<QualitySessionRow, "id" | "status" | "ai_status" | "ai_total" | "ai_completed" | "ai_failed" | "summary"> & {
      items: Array<Pick<QualityCheckItemRow, "id" | "status" | "ai_status" | "weighted_score" | "reviewed_at" | "ai_completed_at">>
    }>(`/quality/sessions/${encodeURIComponent(sessionId)}/progress`, { signal });
  },

  qualityItem(sessionId: string, itemId: string, signal?: AbortSignal) {
    return apiFetch<QualityCheckItemRow>(
      `/quality/sessions/${encodeURIComponent(sessionId)}/items/${encodeURIComponent(itemId)}`,
      { signal },
    );
  },

  qualityReportHtml(sessionId: string, mode: "summary" | "full") {
    return apiFetchBlob(
      `/quality/sessions/${encodeURIComponent(sessionId)}/html?mode=${mode}`,
    );
  },

  qualityIncorrectResponses(params?: {
    days?: number;
    limit?: number;
    offset?: number;
  }) {
    const q = new URLSearchParams();
    if (params?.days != null) q.set("days", String(params.days));
    if (params?.limit != null) q.set("limit", String(params.limit));
    if (params?.offset != null) q.set("offset", String(params.offset));
    return apiFetch<QualityIncorrectResponsesResponse>(
      `/quality/incorrect-responses?${q.toString()}`,
    );
  },

  qualityIncorrectResponsesHtml(params?: { days?: number }) {
    const q = new URLSearchParams();
    if (params?.days != null) q.set("days", String(params.days));
    return apiFetchBlob(`/quality/incorrect-responses/html?${q.toString()}`);
  },

  qualityActiveSession() {
    return apiFetch<QualitySessionRow | null>("/quality/sessions/active");
  },

  qualityScoreItem(
    sessionId: string,
    itemId: string,
    body: {
      scores?: Record<string, number | string | null>;
      comment?: string | null;
      recommendation?: string | null;
      status?: "reviewed" | "skipped";
    },
  ) {
    return apiFetch<{
      ok: boolean;
      item: QualityCheckItemRow;
      session_summary?: QualitySessionRow["summary"];
      session_status?: string;
    }>(
      `/quality/sessions/${encodeURIComponent(sessionId)}/items/${encodeURIComponent(itemId)}/score`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  qualityCreateIncorrectResponse(
    sessionId: string,
    itemId: string,
    body: {
      message_id: string;
      comment: string;
    },
  ) {
    return apiFetch<{ ok: boolean; item: QualityIncorrectResponseRow }>(
      `/quality/sessions/${encodeURIComponent(sessionId)}/items/${encodeURIComponent(itemId)}/incorrect-responses`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  qualityComplete(sessionId: string) {
    return apiFetch<QualitySessionRow>(
      `/quality/sessions/${encodeURIComponent(sessionId)}/complete`,
      {
        method: "POST",
      },
    );
  },

  qualityCancel(sessionId: string) {
    return apiFetch<QualitySessionRow>(
      `/quality/sessions/${encodeURIComponent(sessionId)}/cancel`,
      {
        method: "POST",
      },
    );
  },

  qualityResume(sessionId: string) {
    return apiFetch<QualitySessionRow>(
      `/quality/sessions/${encodeURIComponent(sessionId)}/resume`,
      {
        method: "POST",
      },
    );
  },

  qualityHistory(params?: { limit?: number; offset?: number }) {
    const q = new URLSearchParams();
    if (params?.limit != null) q.set("limit", String(params.limit));
    if (params?.offset != null) q.set("offset", String(params.offset));
    return apiFetch<QualityHistoryResponse>(`/quality/history?${q.toString()}`);
  },

  qualityReports(params?: { days?: number }) {
    const q = new URLSearchParams();
    if (params?.days != null) q.set("days", String(params.days));
    return apiFetch<QualityReportResponse>(`/quality/reports?${q.toString()}`);
  },

  projectCreate(body: ProjectCreatePayload) {
    return apiFetch<ProjectDetailResponse>("/projects/", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  syncProjectTranslationAssistant(projectId: string) {
    return apiFetch<ProjectDetailResponse>(
      `/projects/${encodeURIComponent(projectId)}/translation/vllm/assistant/sync`,
      { method: "POST" },
    );
  },

  deleteProjectTranslationAssistant(projectId: string) {
    return apiFetch<ProjectDetailResponse>(
      `/projects/${encodeURIComponent(projectId)}/translation/vllm/assistant`,
      {
        method: "DELETE",
      },
    );
  },

  patchTicketTranslationReplyLocale(
    ticketId: string,
    replyLocale: "en" | "tr" | null,
  ) {
    return apiFetch<{
      ok: boolean;
      translation_client_locale?: string | null;
      translation_reply_locale_override?: string | null;
    }>(`/tickets/${encodeURIComponent(ticketId)}/translation-reply-locale`, {
      method: "PATCH",
      body: JSON.stringify({ reply_locale: replyLocale }),
    });
  },

  projectUpdate(projectId: string, body: ProjectUpdatePayload) {
    return apiFetch<ProjectDetailResponse>(
      `/projects/${encodeURIComponent(projectId)}`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  },

  projectQuickSettings(projectId: string, body: ProjectQuickSettingsPayload) {
    return apiFetch<ProjectDetailResponse>(
      `/projects/${encodeURIComponent(projectId)}/quick-settings`,
      {
        method: "PATCH",
        body: JSON.stringify(body),
      },
    );
  },

  projectDelete(projectId: string, confirmProjectName: string) {
    const q = new URLSearchParams();
    q.set("confirm", confirmProjectName);
    return apiFetch<{ message?: string }>(
      `/projects/${encodeURIComponent(projectId)}?${q.toString()}`,
      {
        method: "DELETE",
      },
    );
  },

  projectsReorder(projectIds: string[]) {
    return apiFetch<{ message?: string }>("/projects/reorder", {
      method: "PUT",
      body: JSON.stringify({ project_ids: projectIds }),
    });
  },

  project(projectId: string) {
    return apiFetch<ProjectDetailResponse>(
      `/projects/${encodeURIComponent(projectId)}`,
    );
  },

  projectFields(projectId: string) {
    return apiFetch<ProjectCustomerFieldRow[]>(
      `/projects/${encodeURIComponent(projectId)}/fields`,
    );
  },

  projectUserIdentifiers(
    projectId: string,
    customerId: string,
    opts?: { allProjects?: boolean },
  ) {
    const q = new URLSearchParams();
    if (opts?.allProjects) q.set("all_projects", "true");
    return apiFetch<ProjectUserIdentifierRow[]>(
      `/projects/${encodeURIComponent(projectId)}/user-identifiers/user/${encodeURIComponent(customerId)}${
        q.toString() ? `?${q.toString()}` : ""
      }`,
    );
  },

  projectUserIdentifiersList(
    projectId: string,
    params: { page?: number; page_size?: number; search?: string },
  ) {
    const q = new URLSearchParams();
    if (params.page != null) q.set("page", String(params.page));
    if (params.page_size != null) q.set("page_size", String(params.page_size));
    if (params.search) q.set("search", params.search);
    const qs = q.toString();
    return apiFetch<ProjectUserIdentifiersListResponse>(
      `/projects/${encodeURIComponent(projectId)}/user-identifiers/${qs ? `?${qs}` : ""}`,
    );
  },

  projectUserIdentifierCreate(
    projectId: string,
    body: {
      user_id: string;
      identifier_type: string;
      identifier_value: string;
      display_name?: string | null;
      is_active?: boolean;
    },
  ) {
    return apiFetch<ProjectUserIdentifierRow>(
      `/projects/${encodeURIComponent(projectId)}/user-identifiers/`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  projectUserIdentifierUpdate(
    projectId: string,
    identifierId: string,
    body: {
      identifier_type?: string;
      identifier_value?: string;
      display_name?: string | null;
      is_active?: boolean;
    },
  ) {
    return apiFetch<ProjectUserIdentifierRow>(
      `/projects/${encodeURIComponent(projectId)}/user-identifiers/${encodeURIComponent(identifierId)}`,
      { method: "PUT", body: JSON.stringify(body) },
    );
  },

  projectUserIdentifierDelete(projectId: string, identifierId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/user-identifiers/${encodeURIComponent(identifierId)}`,
      { method: "DELETE" },
    );
  },

  projectUserIdentifierFindUser(
    projectId: string,
    params: {
      identifier_type: string;
      identifier_value: string;
      search_all_types?: boolean;
    },
  ) {
    const q = new URLSearchParams();
    q.set("identifier_type", params.identifier_type);
    q.set("identifier_value", params.identifier_value);
    if (params.search_all_types === true) q.set("search_all_types", "true");
    return apiFetch<ProjectUserIdentifiersListResponse["users"]>(
      `/projects/${encodeURIComponent(projectId)}/user-identifiers/find-user?${q.toString()}`,
    );
  },

  projectUserIdentifierMergeCustomers(
    projectId: string,
    body: {
      from_user_id: string;
      to_user_id: string;
      identifier_type: string;
      identifier_value: string;
    },
  ) {
    return apiFetch<{
      ok: boolean;
      merged: boolean;
      to_user_id: string;
      from_user_id: string;
      moved_tickets: number;
      moved_identifiers: number;
    }>(
      `/projects/${encodeURIComponent(projectId)}/user-identifiers/merge-customers`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  projectUserIdentifierMergeCustomersPreview(
    projectId: string,
    body: {
      from_user_id: string;
      to_user_id: string;
      identifier_type: string;
      identifier_value: string;
    },
  ) {
    return apiFetch<{
      ok: boolean;
      can_merge: boolean;
      moved_tickets: number;
      moved_identifiers: number;
      duplicate_identifiers: number;
      moved_review_requests: number;
      moved_product_review_requests: number;
    }>(
      `/projects/${encodeURIComponent(projectId)}/user-identifiers/merge-customers-preview`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  projectTemplates(projectId: string) {
    return apiFetch<ProjectTemplateRow[]>(
      `/projects/${encodeURIComponent(projectId)}/templates`,
    );
  },

  projectTemplateCreate(
    projectId: string,
    body: {
      name: string;
      content: string;
      subject?: string | null;
      category?: string | null;
      shortcut?: string | null;
    },
  ) {
    return apiFetch<ProjectTemplateRow>(
      `/projects/${encodeURIComponent(projectId)}/templates`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  projectTemplateUpdate(
    projectId: string,
    templateId: string,
    body: {
      name?: string | null;
      content?: string | null;
      subject?: string | null;
      category?: string | null;
      shortcut?: string | null;
      is_active?: boolean | null;
    },
  ) {
    return apiFetch<ProjectTemplateRow>(
      `/projects/${encodeURIComponent(projectId)}/templates/${encodeURIComponent(templateId)}`,
      { method: "PUT", body: JSON.stringify(body) },
    );
  },

  projectTemplateDelete(projectId: string, templateId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/templates/${encodeURIComponent(templateId)}`,
      {
        method: "DELETE",
      },
    );
  },

  projectFieldCreate(
    projectId: string,
    body: {
      name: string;
      field_key: string;
      field_type: string;
      options?: string[] | null;
      allow_custom_values?: boolean;
      is_required?: boolean;
      is_multiple?: boolean;
      is_active?: boolean;
      display_order?: number;
    },
  ) {
    return apiFetch<ProjectCustomerFieldRow>(
      `/projects/${encodeURIComponent(projectId)}/fields`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  projectFieldUpdate(
    projectId: string,
    fieldId: string,
    body: {
      name?: string | null;
      field_type?: string | null;
      options?: string[] | null;
      allow_custom_values?: boolean | null;
      is_required?: boolean | null;
      is_multiple?: boolean | null;
      is_active?: boolean | null;
      display_order?: number | null;
    },
  ) {
    return apiFetch<ProjectCustomerFieldRow>(
      `/projects/${encodeURIComponent(projectId)}/fields/${encodeURIComponent(fieldId)}`,
      { method: "PUT", body: JSON.stringify(body) },
    );
  },

  projectFieldDelete(projectId: string, fieldId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/fields/${encodeURIComponent(fieldId)}`,
      {
        method: "DELETE",
      },
    );
  },

  projectTagCreate(
    projectId: string,
    body: {
      name: string;
      color?: string | null;
      display_order?: number | null;
      ticket_priority?: string | null;
      weight?: number | null;
      time_weight_per_hour?: number | null;
      is_active?: boolean | null;
    },
  ) {
    return apiFetch<ProjectTagRow>(
      `/projects/${encodeURIComponent(projectId)}/tags`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  projectTagUpdate(
    projectId: string,
    tagId: string,
    body: {
      name?: string | null;
      color?: string | null;
      display_order?: number | null;
      ticket_priority?: string | null;
      weight?: number | null;
      time_weight_per_hour?: number | null;
      is_active?: boolean | null;
    },
  ) {
    return apiFetch<ProjectTagRow>(
      `/projects/${encodeURIComponent(projectId)}/tags/${encodeURIComponent(tagId)}`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  },

  projectTagDelete(projectId: string, tagId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/tags/${encodeURIComponent(tagId)}`,
      {
        method: "DELETE",
      },
    );
  },

  projectTagsDeleteAll(projectId: string) {
    return apiFetch<{
      message: string;
      deleted_tags: number;
      archived_tags: number;
      deleted_rules: number;
      deleted_analytics_rows: number;
      cleared_ai_exceptions: number;
      cleared_emergency_modes: number;
      preserved_ticket_tags: number;
    }>(`/projects/${encodeURIComponent(projectId)}/tags`, {
      method: "DELETE",
    });
  },

  projectTagsExport(projectId: string) {
    return apiFetchBlob(
      `/projects/${encodeURIComponent(projectId)}/tags/export`,
    );
  },

  projectTagsImport(projectId: string, file: File) {
    const fd = new FormData();
    fd.append("file", file);
    return apiFetch<{
      created_tags: number;
      updated_tags: number;
      created_rules: number;
      updated_rules: number;
      skipped_rules: number;
    }>(`/projects/${encodeURIComponent(projectId)}/tags/import`, {
      method: "POST",
      body: fd,
    });
  },

  tagRulesList(projectId: string) {
    return apiFetch<TagRuleRow[]>(
      `/projects/${encodeURIComponent(projectId)}/rules`,
    );
  },

  tagRuleCreate(
    projectId: string,
    body: {
      tag_id: string;
      keywords: string;
      assigned_operator_id?: string | null;
      is_active?: boolean;
      priority?: number;
    },
  ) {
    return apiFetch<TagRuleRow>(
      `/projects/${encodeURIComponent(projectId)}/rules`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  tagRuleUpdate(
    projectId: string,
    ruleId: string,
    body: {
      keywords?: string | null;
      assigned_operator_id?: string | null;
      is_active?: boolean | null;
      priority?: number | null;
    },
  ) {
    return apiFetch<TagRuleRow>(
      `/projects/${encodeURIComponent(projectId)}/rules/${encodeURIComponent(ruleId)}`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  },

  tagRuleDelete(projectId: string, ruleId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/rules/${encodeURIComponent(ruleId)}`,
      {
        method: "DELETE",
      },
    );
  },

  /** POST /projects/{id}/test-classification (роут на том же префиксе, без /rules/) */
  tagRuleTestClassification(projectId: string, text: string) {
    return apiFetch<TagRuleClassificationTestResponse>(
      `/projects/${encodeURIComponent(projectId)}/test-classification`,
      { method: "POST", body: JSON.stringify({ text }) },
    );
  },

  tagRuleSuggestKeywords(projectId: string, text: string) {
    return apiFetch<{ suggestions: string[] }>(
      `/projects/${encodeURIComponent(projectId)}/rules/suggest-keywords`,
      {
        method: "POST",
        body: JSON.stringify({ text }),
      },
    );
  },

  /** Как classic `GET /channels/?project_id=` — с завершающим слэшем, иначе часть прокси/редиректов теряет query. */
  channelsList(projectId?: string) {
    const qs = new URLSearchParams();
    if (projectId) qs.set("project_id", projectId);
    const q = qs.toString();
    return apiFetch<ChannelRow[]>(q ? `/channels/?${q}` : "/channels/");
  },

  channelGet(channelId: string) {
    return apiFetch<ChannelDetail>(
      `/channels/${encodeURIComponent(channelId)}`,
    );
  },

  channelCreate(body: ChannelCreatePayload) {
    return apiFetch<ChannelDetail>("/channels/", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  channelUpdate(channelId: string, body: ChannelUpdatePayload) {
    return apiFetch<ChannelDetail>(
      `/channels/${encodeURIComponent(channelId)}`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  },

  channelWidgetBrandingLogoUpload(channelId: string, file: File) {
    const fd = new FormData();
    fd.append("file", file);
    return apiFetch<{ storage_key: string }>(
      `/channels/${encodeURIComponent(channelId)}/widget-branding-logo`,
      {
        method: "POST",
        body: fd,
      },
    );
  },

  channelWidgetBrandingLogoDelete(channelId: string) {
    return apiFetch<{ ok: boolean }>(
      `/channels/${encodeURIComponent(channelId)}/widget-branding-logo`,
      {
        method: "DELETE",
      },
    );
  },

  channelDelete(channelId: string) {
    return apiFetch<unknown>(`/channels/${encodeURIComponent(channelId)}`, {
      method: "DELETE",
    });
  },

  channelRestartTelegramBot(channelId: string) {
    return apiFetch<{ status?: string; message?: string }>(
      `/channels/restart-telegram-bot/${encodeURIComponent(channelId)}`,
      { method: "POST" },
    );
  },

  channelResyncTelegramAttachments(channelId: string, days: number) {
    return apiFetch<{
      attachments_checked?: number;
      telegram_api_checked?: number;
      redownloaded?: number;
      missing?: number;
      size_mismatch?: number;
      no_telegram_file_id?: number;
      placeholder_created?: number;
      issues?: unknown[];
    }>(
      `/channels/${encodeURIComponent(channelId)}/telegram-attachments/resync`,
      {
        method: "POST",
        body: JSON.stringify({ days }),
      },
    );
  },

  channelRepairTicketWorkspaces(
    channelId: string,
    body: { apply: boolean; fix_customers?: boolean },
  ) {
    return apiFetch<{
      applied: boolean;
      workspace_id: string;
      tickets_to_fix: number;
      customers_to_fix: number;
      ambiguous_customers_skipped: number;
      tickets_updated: number;
      tickets_renumbered_due_to_conflict: number;
      customers_updated: number;
      ticket_preview?: unknown[];
      customer_preview?: unknown[];
      ambiguous_customer_preview?: unknown[];
    }>(`/channels/${encodeURIComponent(channelId)}/tickets/workspace-repair`, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  channelListTicketWorkspaceRepairs(
    channelId: string,
    page = 1,
    pageSize = 20,
  ) {
    const params = new URLSearchParams({
      page: String(page),
      page_size: String(pageSize),
    });
    return apiFetch<{
      workspace_id: string;
      items: Array<{
        id: string;
        ticket_number: number;
        old_workspace_id: string | null;
        new_workspace_id: string;
        project_id: string;
        project_name: string | null;
        channel_id: string | null;
        channel_name: string | null;
        channel_type: string | null;
        customer_id: string | null;
        subject: string;
        status: string;
        created_at: string | null;
      }>;
      total: number;
      page: number;
      page_size: number;
      pages: number;
    }>(
      `/channels/${encodeURIComponent(channelId)}/tickets/workspace-repair?${params.toString()}`,
    );
  },

  channelRepairSingleTicketWorkspace(
    channelId: string,
    ticketId: string,
    body: { fix_customers?: boolean } = {},
  ) {
    return apiFetch<{
      ticket_id: string;
      applied: boolean;
      already_correct: boolean;
      old_workspace_id: string | null;
      new_workspace_id: string;
      old_ticket_number: number;
      new_ticket_number: number;
      renumbered_due_to_conflict: boolean;
      customer_updated: boolean;
    }>(
      `/channels/${encodeURIComponent(channelId)}/tickets/workspace-repair/${encodeURIComponent(ticketId)}`,
      {
        method: "POST",
        body: JSON.stringify({ fix_customers: body.fix_customers ?? true }),
      },
    );
  },

  channelTelegramIngestedTickets(
    channelId: string,
    page = 1,
    pageSize = 20,
    search?: string,
  ) {
    const params = new URLSearchParams({
      page: String(page),
      page_size: String(pageSize),
    });
    const q = (search || "").trim();
    if (q) params.set("search", q);
    return apiFetch<{
      channel_id: string;
      items: Array<{
        id: string;
        ticket_number: number;
        project_id: string;
        project_name: string | null;
        project_slug: string | null;
        workspace_id: string | null;
        project_workspace_id: string;
        subject: string;
        status: string;
        customer_name: string | null;
        customer_email: string | null;
        customer_external_id: string | null;
        messages_count: number;
        actual_messages_count: number;
        customer_messages_count: number;
        operator_messages_count: number;
        created_at: string | null;
        updated_at: string | null;
        last_message_content: string | null;
        last_message_type: string | null;
        last_message_sender_name: string | null;
        last_message_at: string | null;
      }>;
      total: number;
      page: number;
      page_size: number;
      pages: number;
    }>(
      `/channels/${encodeURIComponent(channelId)}/telegram-ingested-tickets?${params.toString()}`,
    );
  },

  channelReloadEmailPoller(channelId: string) {
    return apiFetch<{ status?: string; message?: string }>(
      `/channels/reload-email-poller/${encodeURIComponent(channelId)}`,
      { method: "POST" },
    );
  },

  channelEmailBackfill(
    channelId: string,
    body: {
      date_from: string;
      date_to?: string | null;
      apply?: boolean;
      limit?: number;
      batch_size?: number;
    },
  ) {
    return apiFetch<{
      channel_id: string;
      applied: boolean;
      date_from: string;
      date_to: string;
      found: number;
      selected: number;
      processed: number;
      batch_size: number;
      batches: number;
      sent: number;
      failed: number;
      duplicates: number;
      samples: Array<{
        seq?: string | null;
        from?: string | null;
        subject?: string | null;
        message_id?: string | null;
      }>;
      errors: Array<{ seq?: string | null; status?: number; error: string }>;
    }>(`/channels/${encodeURIComponent(channelId)}/email-backfill`, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  exportChannelTicketsPreview(
    channelId: string,
    params: { date_from: string; date_to: string; limit?: number },
  ) {
    const q = new URLSearchParams();
    q.set("date_from", params.date_from);
    q.set("date_to", params.date_to);
    if (params.limit) q.set("limit", String(params.limit));
    return apiFetch<ExportTicketsPreview>(
      `/channels/${encodeURIComponent(channelId)}/tickets-export/preview?${q.toString()}`,
    );
  },

  exportChannelTickets(
    channelId: string,
    params: {
      date_from: string;
      date_to: string;
      limit?: number;
      format?: "csv" | "json";
    },
  ) {
    const q = new URLSearchParams();
    q.set("date_from", params.date_from);
    q.set("date_to", params.date_to);
    q.set("format", params.format || "csv");
    if (params.limit) q.set("limit", String(params.limit));
    return apiFetchBlob(
      `/channels/${encodeURIComponent(channelId)}/tickets-export?${q.toString()}`,
      { _fetchTimeoutMs: FETCH_TIMEOUT_EXPORT_MS },
    );
  },

  projectAnomalySettings(projectId: string) {
    return apiFetch<ProjectAnomalySettingsRow | null>(
      `/projects/${encodeURIComponent(projectId)}/anomaly-settings`,
    );
  },

  projectAnomalySettingsPut(
    projectId: string,
    body: ProjectAnomalySettingsPayload,
  ) {
    return apiFetch<ProjectAnomalySettingsRow>(
      `/projects/${encodeURIComponent(projectId)}/anomaly-settings`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  },

  projectSpamSettings(projectId: string) {
    return apiFetch<ProjectSpamSettings>(
      `/projects/${encodeURIComponent(projectId)}/spam/settings`,
    );
  },

  projectSpamSettingsPut(projectId: string, body: ProjectSpamSettings) {
    return apiFetch<ProjectSpamSettings>(
      `/projects/${encodeURIComponent(projectId)}/spam/settings`,
      { method: "PUT", body: JSON.stringify(body) },
    );
  },

  projectSpamTickets(
    projectId: string,
    params: { search?: string; source?: SpamSource | ""; limit?: number; offset?: number } = {},
  ) {
    const q = new URLSearchParams();
    if (params.search) q.set("search", params.search);
    if (params.source) q.set("source", params.source);
    q.set("limit", String(params.limit ?? 50));
    q.set("offset", String(params.offset ?? 0));
    return apiFetch<SpamPage<SpamTicketRow>>(
      `/projects/${encodeURIComponent(projectId)}/spam/tickets?${q.toString()}`,
    );
  },

  projectSpamBlockedSenders(
    projectId: string,
    params: { active?: boolean; search?: string; limit?: number; offset?: number } = {},
  ) {
    const q = new URLSearchParams();
    q.set("active", String(params.active ?? true));
    if (params.search) q.set("search", params.search);
    q.set("limit", String(params.limit ?? 100));
    q.set("offset", String(params.offset ?? 0));
    return apiFetch<SpamPage<SpamBlockedSenderRow>>(
      `/projects/${encodeURIComponent(projectId)}/spam/blocked-senders?${q.toString()}`,
    );
  },

  projectSpamBlockSender(
    projectId: string,
    body: {
      identifier_type: SpamIdentifierType;
      identifier_value: string;
      reason?: string;
      display_name?: string;
    },
  ) {
    return apiFetch<SpamBlockedSenderRow>(
      `/projects/${encodeURIComponent(projectId)}/spam/blocked-senders`,
      { method: "POST", body: JSON.stringify(body) },
    );
  },

  projectSpamUnblock(projectId: string, blockId: string) {
    return apiFetch<SpamBlockedSenderRow>(
      `/projects/${encodeURIComponent(projectId)}/spam/blocked-senders/${encodeURIComponent(blockId)}/unblock`,
      { method: "POST" },
    );
  },

  ticketSpamState(ticketId: string) {
    return apiFetch<TicketSpamState>(
      `/tickets/${encodeURIComponent(ticketId)}/spam`,
    );
  },

  ticketMarkSpam(ticketId: string, body: { block_sender: boolean; reason?: string }) {
    return apiFetch<TicketSpamState>(
      `/tickets/${encodeURIComponent(ticketId)}/spam`,
      { method: "POST", body: JSON.stringify(body) },
    );
  },

  ticketNotSpam(ticketId: string, body: { unblock_sender: boolean }) {
    return apiFetch<TicketSpamState>(
      `/tickets/${encodeURIComponent(ticketId)}/not-spam`,
      { method: "POST", body: JSON.stringify(body) },
    );
  },

  projectMacros(projectId: string) {
    return apiFetch<MacroRow[]>(
      `/projects/${encodeURIComponent(projectId)}/macros`,
    );
  },

  macroCreate(
    projectId: string,
    body: { name: string; content: string; sort_order?: number },
  ) {
    return apiFetch<MacroRow>(
      `/projects/${encodeURIComponent(projectId)}/macros`,
      {
        method: "POST",
        body: JSON.stringify({ sort_order: 0, ...body }),
      },
    );
  },

  macroUpdate(
    projectId: string,
    macroId: string,
    body: { name?: string; content?: string; sort_order?: number },
  ) {
    return apiFetch<MacroRow>(
      `/projects/${encodeURIComponent(projectId)}/macros/${encodeURIComponent(macroId)}`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  },

  macroDelete(projectId: string, macroId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/macros/${encodeURIComponent(macroId)}`,
      {
        method: "DELETE",
      },
    );
  },

  supportKnowledgeMaterialTypes() {
    return apiFetch<Array<{ key: string; label: string }>>(
      "/knowledge-base/material-types",
    );
  },

  supportKnowledgeVariableDefinitions(params?: { project_id?: string }) {
    const q = new URLSearchParams();
    if (params?.project_id) q.set("project_id", params.project_id);
    const suffix = q.toString() ? `?${q.toString()}` : "";
    return apiFetch<SupportKnowledgeVariableDefinitionRow[]>(
      `/knowledge-base/variable-definitions${suffix}`,
    );
  },

  supportKnowledgeVariables(params?: {
    project_id?: string;
    include_inactive?: boolean;
  }) {
    const q = new URLSearchParams();
    if (params?.project_id) q.set("project_id", params.project_id);
    if (params?.include_inactive) q.set("include_inactive", "true");
    const suffix = q.toString() ? `?${q.toString()}` : "";
    return apiFetch<SupportKnowledgeVariableDefinitionRow[]>(
      `/knowledge-base/variables${suffix}`,
    );
  },

  supportKnowledgeVariableCreate(body: SupportKnowledgeVariableWritePayload) {
    return apiFetch<SupportKnowledgeVariableDefinitionRow>(
      "/knowledge-base/variables",
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  supportKnowledgeVariableUpdate(
    variableId: string,
    body: Partial<SupportKnowledgeVariableWritePayload>,
  ) {
    return apiFetch<SupportKnowledgeVariableDefinitionRow>(
      `/knowledge-base/variables/${encodeURIComponent(variableId)}`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  },

  supportKnowledgeVariableDelete(variableId: string) {
    return apiFetch<unknown>(
      `/knowledge-base/variables/${encodeURIComponent(variableId)}`,
      {
        method: "DELETE",
      },
    );
  },

  supportKnowledgeTags(params?: {
    project_id?: string;
    include_inactive?: boolean;
  }) {
    const q = new URLSearchParams();
    if (params?.project_id) q.set("project_id", params.project_id);
    if (params?.include_inactive) q.set("include_inactive", "true");
    const suffix = q.toString() ? `?${q.toString()}` : "";
    return apiFetch<SupportKnowledgeTagRow[]>(`/knowledge-base/tags${suffix}`);
  },

  supportKnowledgeTagCreate(body: SupportKnowledgeTagWritePayload) {
    return apiFetch<SupportKnowledgeTagRow>("/knowledge-base/tags", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  supportKnowledgeTagUpdate(
    tagId: string,
    body: Partial<SupportKnowledgeTagWritePayload>,
  ) {
    return apiFetch<SupportKnowledgeTagRow>(
      `/knowledge-base/tags/${encodeURIComponent(tagId)}`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  },

  supportKnowledgeTagDelete(tagId: string) {
    return apiFetch<unknown>(
      `/knowledge-base/tags/${encodeURIComponent(tagId)}`,
      {
        method: "DELETE",
      },
    );
  },

  supportKnowledgeTagRules(params?: {
    project_id?: string;
    tag_id?: string;
    include_inactive?: boolean;
  }) {
    const q = new URLSearchParams();
    if (params?.project_id) q.set("project_id", params.project_id);
    if (params?.tag_id) q.set("tag_id", params.tag_id);
    if (params?.include_inactive) q.set("include_inactive", "true");
    const suffix = q.toString() ? `?${q.toString()}` : "";
    return apiFetch<SupportKnowledgeTagRuleRow[]>(
      `/knowledge-base/tag-rules${suffix}`,
    );
  },

  supportKnowledgeTagRuleCreate(body: SupportKnowledgeTagRuleWritePayload) {
    return apiFetch<SupportKnowledgeTagRuleRow>("/knowledge-base/tag-rules", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  supportKnowledgeTagRuleUpdate(
    ruleId: string,
    body: Partial<SupportKnowledgeTagRuleWritePayload>,
  ) {
    return apiFetch<SupportKnowledgeTagRuleRow>(
      `/knowledge-base/tag-rules/${encodeURIComponent(ruleId)}`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  },

  supportKnowledgeTagRuleDelete(ruleId: string) {
    return apiFetch<unknown>(
      `/knowledge-base/tag-rules/${encodeURIComponent(ruleId)}`,
      {
        method: "DELETE",
      },
    );
  },

  supportKnowledgeList(params?: {
    project_id?: string;
    general_only?: boolean;
    material_type?: string;
    include_inactive?: boolean;
    include_content?: boolean;
  }) {
    const q = new URLSearchParams();
    if (params?.project_id) q.set("project_id", params.project_id);
    if (params?.general_only) q.set("general_only", "true");
    if (params?.material_type) q.set("material_type", params.material_type);
    if (params?.include_inactive) q.set("include_inactive", "true");
    if (params?.include_content) q.set("include_content", "true");
    const suffix = q.toString() ? `?${q.toString()}` : "";
    return cachedApiFetch<SupportKnowledgeArticleRow[]>(
      `/knowledge-base${suffix}`,
      {},
      30_000,
    );
  },

  supportKnowledgeSearch(
    params: {
      q: string;
      project_id?: string;
      include_general?: boolean;
      general_only?: boolean;
      material_type?: string;
      limit?: number;
      include_content?: boolean;
    },
    init: RequestInit = {},
  ) {
    const q = new URLSearchParams();
    q.set("q", params.q);
    if (params.project_id) q.set("project_id", params.project_id);
    if (params.include_general) q.set("include_general", "true");
    if (params.general_only) q.set("general_only", "true");
    if (params.material_type) q.set("material_type", params.material_type);
    if (params.limit != null) q.set("limit", String(params.limit));
    if (params.include_content) q.set("include_content", "true");
    return cachedApiFetch<SupportKnowledgeSearchRow[]>(
      `/knowledge-base/search?${q.toString()}`,
      init,
      20_000,
    );
  },

  supportKnowledgeSimilar(body: {
    project_id?: string | null;
    title?: string;
    content?: string;
    exclude_id?: string;
    limit?: number;
  }) {
    return apiFetch<SupportKnowledgeSimilarResponse>(
      "/knowledge-base/similar",
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  supportKnowledgePendingChanges(limit = 100) {
    return apiFetch<SupportKnowledgePendingChangesResponse>(
      `/knowledge-base/changes/pending?limit=${encodeURIComponent(String(limit))}`,
    );
  },

  supportKnowledgeAcknowledgeChanges() {
    return apiFetch<SupportKnowledgeAcknowledgeResponse>(
      "/knowledge-base/changes/ack",
      {
        method: "POST",
      },
    );
  },

  supportKnowledgeFinishChangeView(body: {
    view_id: string;
    action: "closed" | "acknowledged";
    last_page_seen: number;
    total_pages: number;
    duration_seconds?: number | null;
  }) {
    return apiFetch<SupportKnowledgeViewFinishResponse>(
      "/knowledge-base/changes/view-finish",
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  supportKnowledgeReadStats(historyLimit = 200) {
    return apiFetch<SupportKnowledgeReadStatsResponse>(
      `/knowledge-base/changes/read-stats?history_limit=${encodeURIComponent(String(historyLimit))}`,
    );
  },

  supportKnowledgeTrainingPending() {
    return apiFetch<SupportKnowledgeTrainingPendingResponse>(
      "/knowledge-base/training/pending",
    );
  },

  supportKnowledgeTrainingQuestions(projectId: string) {
    return apiFetch<SupportKnowledgeTrainingQuestionRow[]>(
      `/knowledge-base/training/questions?project_id=${encodeURIComponent(projectId)}`,
    );
  },

  supportKnowledgeTrainingCreateQuestion(
    body: SupportKnowledgeTrainingQuestionPayload,
  ) {
    return apiFetch<SupportKnowledgeTrainingQuestionRow>(
      "/knowledge-base/training/questions",
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  supportKnowledgeTrainingUpdateQuestion(
    questionId: string,
    body: Partial<SupportKnowledgeTrainingQuestionPayload>,
  ) {
    return apiFetch<SupportKnowledgeTrainingQuestionRow>(
      `/knowledge-base/training/questions/${encodeURIComponent(questionId)}`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  },

  supportKnowledgeTrainingDeleteQuestion(questionId: string) {
    return apiFetch<unknown>(
      `/knowledge-base/training/questions/${encodeURIComponent(questionId)}`,
      {
        method: "DELETE",
      },
    );
  },

  supportKnowledgeTrainingSubmitAttempt(body: {
    project_id: string;
    answers: Array<{ question_id: string; answer?: string | string[] | null }>;
  }) {
    return apiFetch<SupportKnowledgeTrainingAttemptRow>(
      "/knowledge-base/training/attempts",
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  supportKnowledgeTrainingStats(projectId?: string, limit = 300) {
    const q = new URLSearchParams();
    q.set("limit", String(limit));
    if (projectId) q.set("project_id", projectId);
    return apiFetch<SupportKnowledgeTrainingStatsResponse>(
      `/knowledge-base/training/stats?${q.toString()}`,
    );
  },

  supportKnowledgeTrainingReviewAttempt(
    attemptId: string,
    body: {
      status: "pending_review" | "passed" | "failed";
      score?: number | null;
      reviewer_comment?: string | null;
    },
  ) {
    return apiFetch<SupportKnowledgeTrainingAttemptRow>(
      `/knowledge-base/training/attempts/${encodeURIComponent(attemptId)}/review`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  supportKnowledgeGet(articleId: string) {
    return apiFetch<SupportKnowledgeArticleRow>(
      `/knowledge-base/${encodeURIComponent(articleId)}`,
    );
  },

  supportKnowledgeResolve(title: string, projectId?: string | null) {
    const params = new URLSearchParams({ title });
    if (projectId) params.set("project_id", projectId);
    return apiFetch<SupportKnowledgeArticleRow>(`/knowledge-base/resolve-reference?${params}`);
  },

  supportKnowledgeBulkDelete(body: {
    scope: "general" | "project" | "workspace";
    project_id?: string | null;
    material_type?: string | null;
    confirmation_token?: string;
  }, preview = false) {
    return apiFetch<{ count: number; confirmation_token: string; deleted: number }>(
      `/knowledge-base/bulk-delete${preview ? "/preview" : ""}`,
      { method: "POST", body: JSON.stringify(body) },
    );
  },

  supportKnowledgeCreate(body: SupportKnowledgeArticleWritePayload) {
    return apiFetch<SupportKnowledgeArticleRow>("/knowledge-base", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  supportKnowledgeUpdate(
    articleId: string,
    body: Partial<SupportKnowledgeArticleWritePayload>,
  ) {
    return apiFetch<SupportKnowledgeArticleRow>(
      `/knowledge-base/${encodeURIComponent(articleId)}`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  },

  supportKnowledgeDelete(articleId: string) {
    return apiFetch<unknown>(
      `/knowledge-base/${encodeURIComponent(articleId)}`,
      { method: "DELETE" },
    );
  },

  supportKnowledgeUploadImage(file: File) {
    const fd = new FormData();
    fd.append("file", file);
    return apiFetch<SupportKnowledgeImageUploadResponse>(
      "/knowledge-base/upload-image",
      {
        method: "POST",
        body: fd,
      },
    );
  },

  supportKnowledgeUploadAttachment(articleId: string, file: File) {
    const fd = new FormData();
    fd.append("file", file);
    return apiFetch<SupportKnowledgeAttachmentRow>(
      `/knowledge-base/${encodeURIComponent(articleId)}/attachments`,
      {
        method: "POST",
        body: fd,
      },
    );
  },

  supportKnowledgeDeleteAttachment(attachmentId: string) {
    return apiFetch<unknown>(
      `/knowledge-base/attachments/${encodeURIComponent(attachmentId)}`,
      {
        method: "DELETE",
      },
    );
  },

  supportKnowledgeExportExcel(params?: {
    project_id?: string;
    general_only?: boolean;
    material_type?: string;
    include_inactive?: boolean;
  }) {
    const q = new URLSearchParams();
    if (params?.project_id) q.set("project_id", params.project_id);
    if (params?.general_only) q.set("general_only", "true");
    if (params?.material_type) q.set("material_type", params.material_type);
    if (params?.include_inactive === false) q.set("include_inactive", "false");
    const suffix = q.toString() ? `?${q.toString()}` : "";
    return apiFetchBlob(`/knowledge-base/export-excel${suffix}`);
  },

  supportKnowledgeExportArticleJson(articleId: string) {
    return apiFetchBlob(
      `/knowledge-base/${encodeURIComponent(articleId)}/export-json`,
    );
  },

  supportKnowledgeUploadExcel(
    file: File,
    params?: {
      project_id?: string;
      general_only?: boolean;
      material_type?: string;
    },
  ) {
    const q = new URLSearchParams();
    if (params?.project_id) q.set("project_id", params.project_id);
    if (params?.general_only) q.set("general_only", "true");
    if (params?.material_type) q.set("material_type", params.material_type);
    const suffix = q.toString() ? `?${q.toString()}` : "";
    const fd = new FormData();
    fd.append("file", file);
    return apiFetch<{
      message?: string;
      created?: number;
      updated?: number;
      skipped?: number;
    }>(`/knowledge-base/upload-excel${suffix}`, { method: "POST", body: fd });
  },

  supportKnowledgeImportArticleJson(articleId: string, file: File) {
    const fd = new FormData();
    fd.append("file", file);
    return apiFetch<SupportKnowledgeArticleRow>(
      `/knowledge-base/${encodeURIComponent(articleId)}/import-json`,
      {
        method: "POST",
        body: fd,
      },
    );
  },

  /** Подсказки по переменным шаблонов [name] */
  templateVariables() {
    return apiFetch<Record<string, string>>("/variables");
  },

  replyFavoritesGet(projectId: string) {
    const q = new URLSearchParams();
    q.set("project_id", projectId);
    return apiFetch<ReplyFavoritesResponse>(
      `/users/me/reply-favorites?${q.toString()}`,
    );
  },

  replyFavoritesPut(body: ReplyFavoritesUpdatePayload) {
    return apiFetch<ReplyFavoritesResponse>("/users/me/reply-favorites", {
      method: "PUT",
      body: JSON.stringify(body),
    });
  },

  ticketUpdate(ticketId: string, body: Record<string, unknown>) {
    return apiFetch<TicketGetResponse>(`/tickets/${encodeURIComponent(ticketId)}`, {
      method: "PUT",
      body: JSON.stringify(body),
    });
  },

  ticketsBulkReply(body: TicketsBulkReplyPayload) {
    return apiFetch<unknown>("/tickets/bulk-reply", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  ticketsBulkUpdate(body: {
    ticket_ids: string[];
    status?: string;
    assigned_to_id?: string | null;
    pending_reason?: string;
    pending_comment?: string;
  }) {
    return apiFetch<{ updated: number; requested: number }>(
      "/tickets/bulk-update",
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  projectTags(projectId: string) {
    return apiFetch<ProjectTagRow[]>(`/projects/${projectId}/tags`);
  },

  ticketCounts() {
    return coalesceTicketCounts(() =>
      apiFetch<TicketCountsResponse>("/tickets/counts"),
    );
  },

  filtersList() {
    return apiFetch<{ filters: SavedFilterRow[] }>("/filters/");
  },

  filterCreate(body: SavedFilterCreatePayload) {
    return apiFetch<SavedFilterRow>("/filters/", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  filterUpdate(filterId: string, body: SavedFilterUpdatePayload) {
    return apiFetch<SavedFilterRow>(
      `/filters/${encodeURIComponent(filterId)}`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  },

  filterDelete(filterId: string) {
    return apiFetch<{ message?: string }>(
      `/filters/${encodeURIComponent(filterId)}`,
      {
        method: "DELETE",
      },
    );
  },

  myPermissions() {
    return apiFetch<MyPermissionsResponse>("/workspaces/me/my-permissions");
  },

  workspaceMe() {
    return apiFetch<WorkspaceRow>("/workspaces/me");
  },

  workspaceUpdate(body: WorkspaceUpdatePayload) {
    return apiFetch<WorkspaceRow>("/workspaces/me", {
      method: "PUT",
      body: JSON.stringify(body),
    }).then((row) => {
      invalidateAnalyticsResponseCache();
      return row;
    });
  },

  workspaceQuickSettings(body: WorkspaceQuickSettingsPayload) {
    return apiFetch<WorkspaceRow>("/workspaces/me/quick-settings", {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },

  workspaceSlaRules() {
    return apiFetch<WorkspaceSlaRulesResponse>("/workspaces/me/sla-rules");
  },

  workspaceSlaRulesUpdate(body: WorkspaceSlaRulesResponse) {
    return apiFetch<WorkspaceSlaRulesResponse>("/workspaces/me/sla-rules", {
      method: "PUT",
      body: JSON.stringify(body),
    });
  },

  syncScheduleAiVllmAssistant() {
    return apiFetch<WorkspaceRow>(
      "/workspaces/me/schedule-ai/vllm/assistant/sync",
      { method: "POST" },
    );
  },

  deleteScheduleAiVllmAssistant() {
    return apiFetch<WorkspaceRow>("/workspaces/me/schedule-ai/vllm/assistant", {
      method: "DELETE",
    });
  },

  scheduleStaffingAnalysisLatest(yearMonth?: string | null) {
    const q =
      yearMonth && yearMonth.trim().length > 0
        ? `?year_month=${encodeURIComponent(yearMonth.trim())}`
        : "";
    return apiFetch<ScheduleStaffingAnalysisRow | null>(
      `/schedules/staffing-analysis/latest${q}`,
    );
  },

  scheduleStaffingAnalysisGenerate(body?: { year_month?: string | null }) {
    return apiFetch<ScheduleStaffingAnalysisRow>(
      "/schedules/staffing-analysis/generate",
      {
        method: "POST",
        body: JSON.stringify(body ?? {}),
        _fetchTimeoutMs: FETCH_TIMEOUT_LLM_MS,
      },
    );
  },

  scheduleStaffingAnalysisGenerateSection(body: {
    year_month?: string | null;
    section: ScheduleStaffingSectionKey;
  }) {
    return apiFetch<ScheduleStaffingSectionResponse>(
      "/schedules/staffing-analysis/generate-section",
      {
        method: "POST",
        body: JSON.stringify(body),
        _fetchTimeoutMs: FETCH_TIMEOUT_LLM_MS,
      },
    );
  },

  mattermostBotTest(body: { site_url: string; token: string }) {
    return apiFetch<MattermostBotTestResponse>("/workspaces/me/mm-bot/test", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  mattermostDigestSendNow(destination_idx?: number) {
    const q = new URLSearchParams();
    if (destination_idx != null)
      q.set("destination_idx", String(destination_idx));
    const qs = q.toString();
    return apiFetch<{
      ok: boolean;
      queued?: boolean;
      notification_ids?: string[];
      error?: string;
    }>(
      `/workspaces/me/mm-digest/send-now${qs ? `?${qs}` : ""}`,
      {
        method: "POST",
      },
    );
  },

  workspaceRolePermissionUpdate(
    role: string,
    body: RolePermissionUpdatePayload,
  ) {
    return apiFetch<RolePermissionItem>(
      `/workspaces/me/role-permissions/${encodeURIComponent(role)}`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  },

  workspaceRolePermissionCreate(body: RolePermissionCreatePayload) {
    return apiFetch<RolePermissionItem>("/workspaces/me/role-permissions", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  workspaceRolePermissionDelete(role: string) {
    return apiFetch<{ message?: string }>(
      `/workspaces/me/role-permissions/${encodeURIComponent(role)}`,
      {
        method: "DELETE",
      },
    );
  },

  triggersList() {
    return apiFetch<TriggerRow[]>("/triggers/");
  },

  triggerCreate(body: TriggerCreatePayload) {
    return apiFetch<TriggerRow>("/triggers/", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  triggerUpdate(triggerId: string, body: TriggerUpdatePayload) {
    return apiFetch<TriggerRow>(`/triggers/${encodeURIComponent(triggerId)}`, {
      method: "PUT",
      body: JSON.stringify(body),
    });
  },

  triggerDelete(triggerId: string) {
    return apiFetch<{ message?: string }>(
      `/triggers/${encodeURIComponent(triggerId)}`,
      {
        method: "DELETE",
      },
    );
  },

  loadTestProjects() {
    return apiFetch<LoadTestProjectOption[]>("/load-test/projects");
  },

  loadTestStatus() {
    return apiFetch<LoadTestStatusResponse>("/load-test/status");
  },

  loadTestErrors(
    sessionId: string,
    params?: { page?: number; per_page?: number },
  ) {
    const q = new URLSearchParams();
    q.set("session_id", sessionId);
    if (params?.page != null) q.set("page", String(params.page));
    if (params?.per_page != null) q.set("per_page", String(params.per_page));
    return apiFetch<LoadTestErrorsResponse>(
      `/load-test/errors?${q.toString()}`,
    );
  },

  loadTestStart(body: { projects: LoadTestProjectConfig[] }) {
    return apiFetch<LoadTestStartResponse>("/load-test/start", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  loadTestStop(body: { session_id?: string; stop_all?: boolean }) {
    return apiFetch<unknown>("/load-test/stop", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  currentShift() {
    return apiFetch<CurrentShiftResponse>("/schedules/shifts/current");
  },

  scheduleColleaguesToday() {
    return apiFetch<ColleaguesTodayResponse>(
      "/schedules/shifts/colleagues-today",
    );
  },

  scheduleOnShiftUserIds() {
    return apiFetch<OnShiftUserIdsResponse>(
      "/schedules/shifts/on-shift-user-ids",
    );
  },

  scheduleShiftStatusBadges() {
    return apiFetch<ShiftStatusBadgesResponse>(
      "/schedules/shifts/status-badges",
    );
  },

  startShift() {
    return apiFetch<{ id: string; started_at: string }>(
      "/schedules/shifts/start",
      { method: "POST" },
    );
  },

  endShift() {
    return apiFetch<unknown>("/schedules/shifts/end", { method: "POST" });
  },

  forceEndShift(userId: string) {
    return apiFetch<unknown>(
      `/schedules/shifts/${encodeURIComponent(userId)}/force-end`,
      {
        method: "POST",
      },
    );
  },

  startBreak() {
    return apiFetch<unknown>("/schedules/shifts/break/start", {
      method: "POST",
    });
  },

  endBreak() {
    return apiFetch<EndBreakResponse>("/schedules/shifts/break/end", {
      method: "POST",
    });
  },

  scheduleUsers() {
    return apiFetch<ScheduleUserRow[]>("/schedules/users");
  },

  scheduleMonth(userId: string, year: number, month: number) {
    const q = new URLSearchParams({ year: String(year), month: String(month) });
    return apiFetch<ScheduleMonthApiResponse>(
      `/schedules/month/${encodeURIComponent(userId)}?${q}`,
    );
  },

  scheduleCreate(body: {
    user_id: string;
    date: string;
    work_intervals: ScheduleWorkInterval[];
    break_start?: string | null;
    break_end?: string | null;
  }) {
    return apiFetch<ScheduleResponseRow>("/schedules/", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  scheduleUpdate(
    scheduleId: number,
    body: {
      work_intervals: ScheduleWorkInterval[];
      break_intervals?: ScheduleWorkInterval[];
    },
  ) {
    return apiFetch<ScheduleResponseRow>(`/schedules/${scheduleId}`, {
      method: "PUT",
      body: JSON.stringify(body),
    });
  },

  scheduleDelete(scheduleId: number) {
    return apiFetch<{ message?: string }>(`/schedules/${scheduleId}`, {
      method: "DELETE",
    });
  },

  scheduleShiftsMonth(year: number, month: number) {
    const q = new URLSearchParams({ year: String(year), month: String(month) });
    return apiFetch<ShiftsMonthResponse>(`/schedules/shifts/month?${q}`);
  },

  scheduleRangeSummary(body: {
    start_date: string;
    end_date: string;
    user_ids?: string[];
  }) {
    return apiFetch<ScheduleRangeSummaryResponse>("/schedules/range-summary", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  scheduleBulkDeleteRange(body: {
    start_date: string;
    end_date: string;
    user_ids: string[];
  }) {
    return apiFetch<ScheduleBulkDeleteRangeResponse>(
      "/schedules/bulk-delete-range",
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  debugScanShiftBreaks() {
    return apiFetch<DebugShiftBreakScanResponse>(
      "/schedules/debug/shift-breaks",
    );
  },

  debugRepairShiftBreaks(body: {
    dry_run?: boolean;
    shift_log_ids?: string[];
    user_ids?: string[];
  }) {
    return apiFetch<DebugShiftBreakRepairResponse>(
      "/schedules/debug/shift-breaks/repair",
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  scheduleTemplateFromMonth(year: number, month: number, byWeekday = false) {
    const q = new URLSearchParams({
      year: String(year),
      month: String(month),
      by_weekday: String(byWeekday),
    });
    return apiFetch<{ message?: string; copied?: number }>(
      `/schedules/template/from-month?${q}`,
      {
        method: "POST",
      },
    );
  },

  scheduleTemplateApply(
    year: number,
    month: number,
    overwrite = true,
    byWeekday = false,
  ) {
    const q = new URLSearchParams({
      year: String(year),
      month: String(month),
      overwrite: String(overwrite),
      by_weekday: String(byWeekday),
    });
    return apiFetch<{ message?: string }>(`/schedules/template/apply?${q}`, {
      method: "POST",
    });
  },

  bookmarksList(opts?: { idsOnly?: boolean }) {
    const q = opts?.idsOnly ? "?ids_only=true" : "";
    return apiFetch<BookmarksListResponse>(`/bookmarks/${q}`);
  },

  bookmarkAdd(ticketId: string) {
    return apiFetch<{ message?: string }>(
      `/bookmarks/${encodeURIComponent(ticketId)}`,
      {
        method: "POST",
      },
    );
  },

  bookmarkClearAll(query?: { project_id?: string; search?: string }) {
    const q = new URLSearchParams();
    if (query?.project_id) q.set("project_id", query.project_id);
    if (query?.search) q.set("search", query.search);
    const qs = q.toString();
    return apiFetch<ClearBookmarksResponse>(
      `/bookmarks/${qs ? `?${qs}` : ""}`,
      {
        method: "DELETE",
      },
    );
  },

  bookmarkClearMany(ticketIds: string[]) {
    return apiFetch<ClearBookmarksResponse>("/bookmarks/bulk-delete", {
      method: "POST",
      body: JSON.stringify({ ticket_ids: ticketIds }),
    });
  },

  bookmarkRemove(ticketId: string) {
    return apiFetch<{ message?: string }>(
      `/bookmarks/${encodeURIComponent(ticketId)}`,
      {
        method: "DELETE",
      },
    );
  },

  bookmarkCheck(ticketId: string) {
    return apiFetch<{ is_bookmarked: boolean }>(
      `/bookmarks/check/${encodeURIComponent(ticketId)}`,
    );
  },

  ticketGet(ticketId: string) {
    return apiFetch<TicketGetResponse>(
      `/tickets/${encodeURIComponent(ticketId)}`,
    );
  },

  ticketDetail(
    ticketId: string,
    opts?: { messagesLimit?: number; messagesOffset?: number },
  ) {
    const q = new URLSearchParams();
    q.set("messages_limit", String(opts?.messagesLimit ?? 50));
    q.set("messages_offset", String(opts?.messagesOffset ?? 0));
    return apiFetch<TicketDetailResponse>(
      `/tickets/${encodeURIComponent(ticketId)}/detail?${q.toString()}`,
    );
  },

  ticketSdAdminApiAction(
    ticketId: string,
    action: TicketSdAdminApiAction,
    body?: { email?: string; send_to_customer?: boolean },
  ) {
    return apiFetch<TicketSdAdminApiActionResponse>(
      `/tickets/${encodeURIComponent(ticketId)}/sd-admin-api/actions/${encodeURIComponent(action)}`,
      { method: "POST", body: body ? JSON.stringify(body) : undefined },
    );
  },

  ticketSimilarClosed(ticketId: string, limit = 15) {
    const q = new URLSearchParams();
    q.set("limit", String(limit));
    return apiFetch<SimilarClosedTicketsResponse>(
      `/tickets/${encodeURIComponent(ticketId)}/similar-closed?${q.toString()}`,
    );
  },

  ticketOpen(ticketId: string) {
    return apiFetch<unknown>(`/tickets/${encodeURIComponent(ticketId)}/open`, {
      method: "POST",
    });
  },

  ticketClose(ticketId: string) {
    return apiFetch<unknown>(`/tickets/${encodeURIComponent(ticketId)}/close`, {
      method: "POST",
    });
  },

  ticketViewers(ticketId: string) {
    return apiFetch<{ viewers: TicketViewerRow[] }>(
      `/tickets/${encodeURIComponent(ticketId)}/viewers`,
    );
  },

  ticketViewersBatch(ticketIds: string[]) {
    return apiFetch<{ viewers: Record<string, TicketViewerRow[]> }>(
      `/tickets/viewers/batch`,
      {
        method: "POST",
        body: JSON.stringify(ticketIds),
      },
    );
  },

  messageCreate(body: {
    ticket_id: string;
    content: string;
    message_type?: string;
    is_internal?: boolean;
    quote_message_id?: string | null;
    template_id?: string | null;
    /** Виджет: дублировать ответ на email из custom_fields (SMTP-канал проекта). */
    send_reply_to_widget_email?: boolean;
  }) {
    return apiFetch<Record<string, unknown>>("/messages/", {
      method: "POST",
      body: JSON.stringify({
        message_type: "operator",
        ...body,
      }),
    });
  },

  messageCreateWithFiles(formData: FormData) {
    return apiFetch<Record<string, unknown>>("/messages/with-files", {
      method: "POST",
      body: formData,
    });
  },

  customer(customerId: string) {
    return apiFetch<CustomerRow>(
      `/customers/${encodeURIComponent(customerId)}`,
    );
  },

  customerUpdate(customerId: string, body: Record<string, unknown>) {
    return apiFetch<CustomerRow>(
      `/customers/${encodeURIComponent(customerId)}`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  },

  customerPreviousTickets(
    customerId: string,
    currentTicketId?: string,
    limit?: number,
    lookbackDays?: number,
    offset?: number,
  ) {
    const q = new URLSearchParams();
    if (currentTicketId) q.set("current_ticket_id", currentTicketId);
    if (limit != null) q.set("limit", String(limit));
    if (lookbackDays != null) q.set("lookback_days", String(lookbackDays));
    if (offset != null) q.set("offset", String(offset));
    const qs = q.toString();
    return apiFetch<TicketListItem[]>(
      `/tickets/customer/${encodeURIComponent(customerId)}/previous${qs ? `?${qs}` : ""}`,
    );
  },

  parallelCustomerTickets(ticketId: string) {
    return apiFetch<ParallelCustomerTicketsResponse>(
      `/tickets/${encodeURIComponent(ticketId)}/parallel-customer-tickets`,
    );
  },

  customerAttachments(customerId: string) {
    return apiFetch<CustomerAttachmentItem[]>(
      `/tickets/customer/${encodeURIComponent(customerId)}/attachments`,
    );
  },

  requestTicketHelp(ticketId: string, message: string) {
    return apiFetch<unknown>(
      `/tickets/${encodeURIComponent(ticketId)}/request-help`,
      {
        method: "POST",
        body: JSON.stringify({ message }),
      },
    );
  },

  requestTicketReview(ticketId: string) {
    return apiFetch<unknown>(
      `/tickets/${encodeURIComponent(ticketId)}/request-review`,
      {
        method: "POST",
      },
    );
  },

  ticketReviewStatus(ticketId: string) {
    return apiFetch<TicketReviewStatusResponse>(
      `/tickets/${encodeURIComponent(ticketId)}/review-status`,
    );
  },

  ticketProductReviewStatus(ticketId: string) {
    return apiFetch<TicketProductReviewStatusResponse>(
      `/tickets/${encodeURIComponent(ticketId)}/product-review-status`,
    );
  },

  /** Установить/снять флаг «отзыв получен» по запросу отзыва о продукте. */
  setProductReviewReceived(requestId: string, reviewReceived: boolean) {
    return apiFetch<{
      id: string;
      review_received: boolean;
      review_received_at: string | null;
    }>(`/tickets/product-review-requests/${encodeURIComponent(requestId)}`, {
      method: "PATCH",
      body: JSON.stringify({ review_received: reviewReceived }),
    });
  },

  /** Тело — JSON-массив имён ссылок, например `["all"]` (как в классическом api.js). */
  requestTicketProductReview(ticketId: string, linkNames: string[]) {
    return apiFetch<{
      message: string;
      product_review_request_id: string;
      delivery_status?: "pending" | "sent" | "failed" | "skipped" | null;
      operator_message?: unknown;
    }>(`/tickets/${encodeURIComponent(ticketId)}/request-product-review`, {
      method: "POST",
      body: JSON.stringify(linkNames),
    });
  },

  generateConversationSummary(ticketId: string) {
    return apiFetch<unknown>(
      `/messages/ticket/${encodeURIComponent(ticketId)}/generate-summary`,
      { method: "POST" },
    );
  },

  projectAICapabilities(projectId: string) {
    return apiFetch<{ is_enabled: boolean; provider_type: string | null }>(
      `/projects/${encodeURIComponent(projectId)}/ai/capabilities`,
    );
  },

  projectAI(projectId: string) {
    return apiFetch<ProjectAISettingsResponse>(
      `/projects/${encodeURIComponent(projectId)}/ai`,
    );
  },

  projectAIUpdate(projectId: string, body: ProjectAIUpdatePayload) {
    return apiFetch<ProjectAISettingsResponse>(
      `/projects/${encodeURIComponent(projectId)}/ai`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  },

  projectAIReleaseTickets(projectId: string) {
    return apiFetch<ProjectAIReleaseTicketsResponse>(
      `/projects/${encodeURIComponent(projectId)}/ai/release-tickets`,
      {
        method: "POST",
      },
    );
  },

  aiInstructionsList(projectId: string) {
    return apiFetch<AIInstructionRow[]>(
      `/projects/${encodeURIComponent(projectId)}/ai/instructions`,
    );
  },

  suggestAIInstructionFromTicket(projectId: string, ticketId: string) {
    return apiFetch<SuggestAIInstructionFromTicketResponse>(
      `/projects/${encodeURIComponent(projectId)}/ai/instructions/suggest-from-ticket/${encodeURIComponent(ticketId)}`,
      { method: "POST", _fetchTimeoutMs: FETCH_TIMEOUT_LLM_MS },
    );
  },

  createAIInstruction(projectId: string, body: AIInstructionWritePayload) {
    return apiFetch<AIInstructionRow>(
      `/projects/${encodeURIComponent(projectId)}/ai/instructions`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  updateAIInstruction(
    projectId: string,
    instructionId: string,
    body: AIInstructionWritePayload,
  ) {
    return apiFetch<AIInstructionRow>(
      `/projects/${encodeURIComponent(projectId)}/ai/instructions/${encodeURIComponent(instructionId)}`,
      { method: "PUT", body: JSON.stringify(body) },
    );
  },

  deleteAIInstruction(projectId: string, instructionId: string) {
    return apiFetch<{ message?: string }>(
      `/projects/${encodeURIComponent(projectId)}/ai/instructions/${encodeURIComponent(instructionId)}`,
      { method: "DELETE" },
    );
  },

  deleteAllAIInstructions(projectId: string) {
    return apiFetch<{ message?: string; count?: number }>(
      `/projects/${encodeURIComponent(projectId)}/ai/instructions`,
      { method: "DELETE" },
    );
  },

  activateAllAIInstructions(projectId: string) {
    return apiFetch<{ message?: string }>(
      `/projects/${encodeURIComponent(projectId)}/ai/instructions/activate-all`,
      {
        method: "PUT",
      },
    );
  },

  bulkDeactivateAIInstructions(projectId: string, instructionIds: string[]) {
    return apiFetch<{ message?: string; count?: number }>(
      `/projects/${encodeURIComponent(projectId)}/ai/instructions/bulk-deactivate`,
      {
        method: "PUT",
        body: JSON.stringify({ instruction_ids: instructionIds }),
      },
    );
  },

  createTagsFromAIInstructions(projectId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/ai/instructions/create-tags-from-instructions`,
      {
        method: "POST",
      },
    );
  },

  uploadAIInstructionsExcel(projectId: string, file: File) {
    const fd = new FormData();
    fd.append("file", file);
    return apiFetch<{ message?: string; count?: number }>(
      `/projects/${encodeURIComponent(projectId)}/ai/instructions/upload-excel`,
      { method: "POST", body: fd },
    );
  },

  exportAIInstructionsExcel(projectId: string) {
    return apiFetchBlob(
      `/projects/${encodeURIComponent(projectId)}/ai/instructions/export-excel`,
    );
  },

  knowledgeBaseList(projectId: string, category?: string) {
    const q = category ? `?category=${encodeURIComponent(category)}` : "";
    return apiFetch<AIKnowledgeBaseRow[]>(
      `/projects/${encodeURIComponent(projectId)}/ai/knowledge-base${q}`,
    );
  },

  knowledgeBaseCreate(projectId: string, body: AIKnowledgeBaseCreatePayload) {
    return apiFetch<AIKnowledgeBaseRow>(
      `/projects/${encodeURIComponent(projectId)}/ai/knowledge-base`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  knowledgeBaseUpdate(
    projectId: string,
    itemId: string,
    body: AIKnowledgeBaseUpdatePayload,
  ) {
    return apiFetch<AIKnowledgeBaseRow>(
      `/projects/${encodeURIComponent(projectId)}/ai/knowledge-base/${encodeURIComponent(itemId)}`,
      { method: "PUT", body: JSON.stringify(body) },
    );
  },

  knowledgeBaseDelete(projectId: string, itemId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/ai/knowledge-base/${encodeURIComponent(itemId)}`,
      { method: "DELETE" },
    );
  },

  knowledgeBaseDeleteAll(projectId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/ai/knowledge-base`,
      {
        method: "DELETE",
      },
    );
  },

  uploadKnowledgeBaseExcel(projectId: string, file: File) {
    const fd = new FormData();
    fd.append("file", file);
    return apiFetch<{ message?: string; count?: number }>(
      `/projects/${encodeURIComponent(projectId)}/ai/knowledge-base/upload-excel`,
      { method: "POST", body: fd },
    );
  },

  exportKnowledgeBaseExcel(projectId: string) {
    return apiFetchBlob(
      `/projects/${encodeURIComponent(projectId)}/ai/knowledge-base/export-excel`,
    );
  },

  aiLinksInventory(projectId: string) {
    return apiFetch<AILinkInventoryResponse>(
      `/projects/${encodeURIComponent(projectId)}/ai/links`,
    );
  },

  aiLinksReplace(projectId: string, body: AILinkReplacePayload) {
    return apiFetch<AILinkReplaceResponse>(
      `/projects/${encodeURIComponent(projectId)}/ai/links/replace`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  aiExceptionsList(projectId: string) {
    return apiFetch<AIExceptionRow[]>(
      `/projects/${encodeURIComponent(projectId)}/ai/exceptions`,
    );
  },

  aiExceptionCreate(projectId: string, body: AIExceptionWritePayload) {
    return apiFetch<AIExceptionRow>(
      `/projects/${encodeURIComponent(projectId)}/ai/exceptions`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  aiExceptionUpdate(
    projectId: string,
    exceptionId: string,
    body: Partial<AIExceptionWritePayload>,
  ) {
    return apiFetch<AIExceptionRow>(
      `/projects/${encodeURIComponent(projectId)}/ai/exceptions/${encodeURIComponent(exceptionId)}`,
      { method: "PUT", body: JSON.stringify(body) },
    );
  },

  aiExceptionDelete(projectId: string, exceptionId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/ai/exceptions/${encodeURIComponent(exceptionId)}`,
      { method: "DELETE" },
    );
  },

  collectVariablesFromInstructions(projectId: string) {
    return apiFetch<{ message?: string; count?: number }>(
      `/projects/${encodeURIComponent(projectId)}/ai/variables/collect-from-instructions`,
      { method: "POST" },
    );
  },

  uploadAIVariablesExcel(projectId: string, file: File) {
    const fd = new FormData();
    fd.append("file", file);
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/ai/variables/upload-excel`,
      {
        method: "POST",
        body: fd,
      },
    );
  },

  exportAIVariablesExcel(projectId: string) {
    return apiFetchBlob(
      `/projects/${encodeURIComponent(projectId)}/ai/variables/export-excel`,
    );
  },

  syncVectorStore(projectId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/ai/sync-vector-store`,
      { method: "POST" },
    );
  },

  syncAssistant(projectId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/ai/sync-assistant`,
      { method: "POST" },
    );
  },

  deleteVectorStore(projectId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/ai/vector-store`,
      { method: "DELETE" },
    );
  },

  deleteAssistant(projectId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/ai/assistant`,
      { method: "DELETE" },
    );
  },

  deleteAllAssistants(projectId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/ai/all-assistants`,
      { method: "DELETE" },
    );
  },

  openAIResources(projectId: string) {
    return apiFetch<OpenAIResourcesResponse>(
      `/projects/${encodeURIComponent(projectId)}/ai/openai-resources`,
    );
  },

  assistantDetails(projectId: string, assistantId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/ai/assistant/${encodeURIComponent(assistantId)}/details`,
    );
  },

  deleteOpenAIVectorStore(projectId: string, vectorStoreId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/ai/openai-resources/vector-store/${encodeURIComponent(vectorStoreId)}`,
      { method: "DELETE" },
    );
  },

  deleteOpenAIAssistantResource(projectId: string, assistantId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/ai/openai-resources/assistant/${encodeURIComponent(assistantId)}`,
      { method: "DELETE" },
    );
  },

  vllmResources(projectId: string) {
    return apiFetch<VLLMResourcesResponse>(
      `/projects/${encodeURIComponent(projectId)}/ai/vllm-resources`,
    );
  },

  syncVLLMVectorStore(projectId: string) {
    return apiFetch<VLLMSyncResponse>(
      `/projects/${encodeURIComponent(projectId)}/ai/sync-vllm-vector-store`,
      {
        method: "POST",
      },
    );
  },

  syncVLLMAssistant(projectId: string) {
    return apiFetch<VLLMSyncResponse>(
      `/projects/${encodeURIComponent(projectId)}/ai/sync-vllm-assistant`,
      {
        method: "POST",
      },
    );
  },

  deleteVLLMVectorStore(projectId: string, vectorStoreId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/ai/vllm-resources/vector-store/${encodeURIComponent(vectorStoreId)}`,
      { method: "DELETE" },
    );
  },

  deleteVLLMAssistantResource(projectId: string, assistantId: string) {
    return apiFetch<unknown>(
      `/projects/${encodeURIComponent(projectId)}/ai/vllm-resources/assistant/${encodeURIComponent(assistantId)}`,
      { method: "DELETE" },
    );
  },

  /** Список оставленных клиентами оценок (как `getReviewsList` в classic). */
  reviewsList(params: Record<string, string | number | boolean | undefined>) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, typeof v === "boolean" ? (v ? "true" : "false") : String(v));
    }
    return apiFetch<ReviewsListResponse>(
      `/analytics/reviews/list?${q.toString()}`,
    );
  },

  debugAiTickets(params: Record<string, string | number | undefined>) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined) continue;
      q.set(k, String(v));
    }
    return apiFetch<DebugAiTicketsResponse>(
      `/tickets/debug-ai?${q.toString()}`,
    );
  },

  debugAiStuck(params: Record<string, string | number | undefined>) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined) continue;
      q.set(k, String(v));
    }
    return apiFetch<DebugAiStuckResponse>(
      `/tickets/debug-ai/stuck?${q.toString()}`,
    );
  },

  debugAiRequests(params: Record<string, string | number | undefined>) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined) continue;
      q.set(k, String(v));
    }
    return apiFetch<DebugAiRequestsResponse>(
      `/tickets/debug-ai/ai-requests?${q.toString()}`,
    );
  },

  debugAutoResolveBlocks(params: Record<string, string | number | undefined>) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined) continue;
      q.set(k, String(v));
    }
    return apiFetch<DebugAutoResolveBlocksResponse>(
      `/tickets/debug-ai/auto-resolve-blocks?${q.toString()}`,
    );
  },

  debugAiQueueBlocks(params: Record<string, string | number | undefined>) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined) continue;
      q.set(k, String(v));
    }
    return apiFetch<DebugAiQueueBlocksResponse>(
      `/tickets/debug-ai/queue-blocks?${q.toString()}`,
    );
  },

  debugSlowFirstResponse(params: Record<string, string | number | undefined>) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, String(v));
    }
    return apiFetch<DebugSlowFirstResponseResponse>(
      `/tickets/debug-ai/slow-first-response?${q.toString()}`,
    );
  },

  debugPendingHistory(params: Record<string, string | number | undefined>) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, String(v));
    }
    return apiFetch<DebugPendingHistoryResponse>(
      `/tickets/debug-ai/pending-history?${q.toString()}`,
    );
  },

  debugClearAiQueueBlocks(
    ticketId: string,
    body: { blocks?: string[]; enqueue?: boolean } = {},
  ) {
    return apiFetch<DebugClearAiQueueBlocksResponse>(
      `/tickets/debug-ai/queue-blocks/${encodeURIComponent(ticketId)}/clear`,
      { method: "POST", body: JSON.stringify(body) },
    );
  },

  debugClearAllAiQueueBlocks(
    params: {
      project_id?: string;
      include_kinds?: string;
      exclude_kinds?: string;
    },
    body: { enqueue?: boolean; blocks?: string[] } = {},
  ) {
    const q = new URLSearchParams();
    if (params.project_id) q.set("project_id", params.project_id);
    if (params.include_kinds) q.set("include_kinds", params.include_kinds);
    if (params.exclude_kinds) q.set("exclude_kinds", params.exclude_kinds);
    const suffix = q.toString() ? `?${q.toString()}` : "";
    return apiFetch<DebugClearAllAiQueueBlocksResponse>(
      `/tickets/debug-ai/queue-blocks/clear-all${suffix}`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  debugClearBatchAiQueueBlocks(body: {
    ticket_ids: string[];
    blocks?: string[];
    enqueue?: boolean;
  }) {
    return apiFetch<DebugClearBatchAiQueueBlocksResponse>(
      "/tickets/debug-ai/queue-blocks/clear-batch",
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  debugMozgobotPipelineReport(params: {
    project_id?: string;
    hours?: number;
    sample_limit?: number;
  }) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, String(v));
    }
    return apiFetch<DebugMozgobotPipelineReportResponse>(
      `/tickets/debug-ai/pipeline-report?${q.toString()}`,
    );
  },

  debugPurgeAiQueue(body: {
    confirm: boolean;
    requeue_waiting_hours?: number;
    max_requeue?: number;
    release_dispatch_claims?: boolean;
  }) {
    return apiFetch<DebugPurgeAiQueueResponse>(
      "/tickets/debug-ai/purge-ai-queue",
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  debugDbConnections() {
    return apiFetch<DebugDbConnectionsResponse>(
      "/tickets/debug-ai/db-connections",
    );
  },

  debugTelegramBackfill(body: {
    channel_id: string;
    apply?: boolean;
    limit?: number;
    max_batches?: number;
    allowed_today_only?: boolean;
  }) {
    return apiFetch<{
      channel_id: string;
      applied: boolean;
      batches: number;
      updates_seen: number;
      updates_processed: number;
      updates_skipped_old: number;
      updates_without_message: number;
      last_update_id: number | null;
      errors: Array<{ update_id?: number; error: string }>;
      note?: string;
    }>("/tickets/debug-ai/telegram-backfill", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  aiAuditLogs(params: {
    days?: number;
    project_id?: string;
    user_id?: string;
    action_group?: string;
    search?: string;
    limit?: number;
    offset?: number;
  }) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, String(v));
    }
    return apiFetch<AIAuditLogsResponse>(
      `/activity-logs/ai-audit?${q.toString()}`,
    );
  },

  anomaliesList(params: {
    project_id?: string;
    days?: number;
    limit?: number;
    offset?: number;
  }) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined) continue;
      q.set(k, String(v));
    }
    return apiFetch<TicketAnomalyRow[]>(`/analytics/anomalies?${q.toString()}`);
  },

  anomalyTickets(anomalyId: string) {
    return apiFetch<AnomalyTicketsResponse>(
      `/analytics/anomalies/${encodeURIComponent(anomalyId)}/tickets`,
    );
  },

  operatorsDetailed(
    params: Record<string, string | number | boolean | undefined>,
  ) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, typeof v === "boolean" ? (v ? "true" : "false") : String(v));
    }
    const qs = q.toString();
    return cachedApiFetch<OperatorsDetailedResponse>(
      `/analytics/operators-detailed${qs ? `?${qs}` : ""}`,
      {
        _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS,
      },
    );
  },

  operatorsDetailedMe(
    params: Record<string, string | number | boolean | undefined>,
  ) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, typeof v === "boolean" ? (v ? "true" : "false") : String(v));
    }
    const qs = q.toString();
    return cachedApiFetch<OperatorDetailedMeResponse>(
      `/analytics/operators-detailed/me${qs ? `?${qs}` : ""}`,
      {
        _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS,
      },
    );
  },

  meDoneByDay(params: Record<string, string | number | boolean | undefined>) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, typeof v === "boolean" ? (v ? "true" : "false") : String(v));
    }
    const qs = q.toString();
    return cachedApiFetch<MeDoneByDayResponse>(
      `/analytics/me-done-by-day${qs ? `?${qs}` : ""}`,
      {
        _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS,
      },
    );
  },

  analyticsProjectTickets(params: Record<string, string | number | boolean | undefined>) {
    const q = new URLSearchParams()
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== '') q.set(key, String(value))
    }
    return cachedApiFetch<{ tickets: TicketListItem[]; total: number }>(
      `/analytics/project-tickets?${q.toString()}`,
      { _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS },
    )
  },

  operatorTicketsBlock(
    params: Record<string, string | number | boolean | undefined>,
  ) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, typeof v === "boolean" ? (v ? "true" : "false") : String(v));
    }
    return cachedApiFetch<OperatorTicketsBlockResponse>(
      `/analytics/operator-tickets?${q.toString()}`,
      {
        _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS,
      },
    );
  },

  analyticsDashboard(
    params: Record<string, string | number | boolean | undefined>,
  ) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, typeof v === "boolean" ? (v ? "true" : "false") : String(v));
    }
    const qs = q.toString();
    return cachedApiFetch<AnalyticsDashboardStats>(
      `/analytics/dashboard${qs ? `?${qs}` : ""}`,
      {
        _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS,
      },
    );
  },

  analyticsAiOperations(
    params: Record<string, string | number | boolean | undefined>,
  ) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, typeof v === "boolean" ? (v ? "true" : "false") : String(v));
    }
    const qs = q.toString();
    return cachedApiFetch<AiOperationsAnalyticsResponse>(
      `/analytics/ai-operations${qs ? `?${qs}` : ""}`,
      {
        _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS,
      },
    );
  },

  analyticsAiTransferTickets(
    params: Record<string, string | number | boolean | undefined>,
  ) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, typeof v === "boolean" ? (v ? "true" : "false") : String(v));
    }
    return cachedApiFetch<OperatorTicketsBlockResponse>(
      `/analytics/ai-transfer-tickets?${q.toString()}`,
      {
        _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS,
      },
    );
  },

  analyticsOperatorsOverview(
    params: Record<string, string | number | boolean | undefined>,
  ) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, typeof v === "boolean" ? (v ? "true" : "false") : String(v));
    }
    const qs = q.toString();
    return cachedApiFetch<OperatorOverviewRow[]>(
      `/analytics/operators${qs ? `?${qs}` : ""}`,
      {
        _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS,
      },
    );
  },

  analyticsOperatorsKtu(
    params: Record<string, string | number | boolean | undefined>,
  ) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, typeof v === "boolean" ? (v ? "true" : "false") : String(v));
    }
    const qs = q.toString();
    const load = () =>
      cachedApiFetch<OperatorsKtuResponse>(
        `/analytics/operators-ktu${qs ? `?${qs}` : ""}`,
        {
          _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS,
        },
      );
    // 504 means the server keeps computing in the background; asking again
    // waits for that same computation instead of starting over.
    const loadWhileComputing = (retriesLeft: number): Promise<OperatorsKtuResponse> =>
      load().catch((e) => {
        if (retriesLeft > 0 && e instanceof ApiError && e.status === 504) {
          return loadWhileComputing(retriesLeft - 1);
        }
        throw e;
      });
    return loadWhileComputing(2);
  },

  analyticsReviewStats(
    params: Record<string, string | number | boolean | undefined>,
  ) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, typeof v === "boolean" ? (v ? "true" : "false") : String(v));
    }
    const qs = q.toString();
    return cachedApiFetch<ReviewStatsResponse>(
      `/analytics/reviews${qs ? `?${qs}` : ""}`,
      {
        _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS,
      },
    );
  },

  analyticsProductReviewStats(
    params: Record<string, string | number | boolean | undefined>,
  ) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, typeof v === "boolean" ? (v ? "true" : "false") : String(v));
    }
    const qs = q.toString();
    return cachedApiFetch<ProductReviewStatsResponse>(
      `/analytics/product-reviews${qs ? `?${qs}` : ""}`,
      {
        _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS,
      },
    );
  },

  analyticsProductReviewReceivedByCustomers(
    params: Record<string, string | number | boolean | undefined>,
  ) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, typeof v === "boolean" ? (v ? "true" : "false") : String(v));
    }
    const qs = q.toString();
    return cachedApiFetch<ProductReviewReceivedByCustomersResponse>(
      `/analytics/product-reviews/received-by-customers${qs ? `?${qs}` : ""}`,
      { _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS },
    );
  },

  analyticsProductReviewStatsByCustomer(
    params: Record<string, string | number | boolean | undefined>,
  ) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, typeof v === "boolean" ? (v ? "true" : "false") : String(v));
    }
    const qs = q.toString();
    return cachedApiFetch<ProductReviewStatsByCustomerResponse>(
      `/analytics/product-reviews/by-customer${qs ? `?${qs}` : ""}`,
      { _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS },
    );
  },

  analyticsReviewsByOperatorSummary(
    params: Record<string, string | number | boolean | undefined>,
  ) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, typeof v === "boolean" ? (v ? "true" : "false") : String(v));
    }
    const qs = q.toString();
    return cachedApiFetch<ReviewsByOperatorSummaryResponse>(
      `/analytics/reviews/by-operator-summary${qs ? `?${qs}` : ""}`,
      { _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS },
    );
  },

  analyticsTagsStats(
    params: Record<string, string | number | boolean | undefined>,
  ) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, typeof v === "boolean" ? (v ? "true" : "false") : String(v));
    }
    const qs = q.toString();
    return cachedApiFetch<TagsStatsResponse>(
      `/analytics/tags${qs ? `?${qs}` : ""}`,
      {
        _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS,
      },
    );
  },

  analyticsTicketHandleTimeouts(params: {
    days?: number;
    project_id?: string;
  }) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, String(v));
    }
    const qs = q.toString();
    return cachedApiFetch<TicketHandleTimeoutsResponse>(
      `/analytics/ticket-handle-timeouts${qs ? `?${qs}` : ""}`,
      {
        _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS,
      },
    );
  },

  analyticsOperatorsByProjectSummary(
    params: Record<string, string | number | boolean | undefined>,
  ) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, typeof v === "boolean" ? (v ? "true" : "false") : String(v));
    }
    const qs = q.toString();
    return cachedApiFetch<OperatorsByProjectSummaryResponse>(
      `/analytics/operators/by-project-summary${qs ? `?${qs}` : ""}`,
      { _fetchTimeoutMs: FETCH_TIMEOUT_ANALYTICS_MS },
    );
  },

  installersList() {
    return apiFetch<InstallerRow[]>("/installers");
  },

  installerCreate(formData: FormData) {
    return apiFetch<InstallerUploadResponse>("/installers", {
      method: "POST",
      body: formData,
    });
  },

  installerUpdate(installerId: string, body: InstallerUpdatePayload) {
    return apiFetch<InstallerRow>(
      `/installers/${encodeURIComponent(installerId)}`,
      {
        method: "PUT",
        body: JSON.stringify(body),
      },
    );
  },

  installerDelete(installerId: string) {
    return apiFetch<{ status?: string; message?: string }>(
      `/installers/${encodeURIComponent(installerId)}`,
      {
        method: "DELETE",
      },
    );
  },

  emergencyCustomTemplates(projectId: string) {
    return apiFetch<EmergencyCustomTemplate[]>(
      `/emergency/custom-templates/${encodeURIComponent(projectId)}`,
    );
  },

  emergencyCustomTemplatesSave(
    projectId: string,
    templates: EmergencyCustomTemplate[],
  ) {
    return apiFetch<EmergencyCustomTemplate[]>(
      `/emergency/custom-templates/${encodeURIComponent(projectId)}`,
      {
        method: "PUT",
        body: JSON.stringify({ templates }),
      },
    );
  },

  emergencyVariables() {
    return apiFetch<Record<string, string>>("/emergency/variables");
  },

  emergencyEnable(body: {
    project_id: string;
    message: string;
    note?: string;
    thread_url?: string;
    excluded_tag_ids?: string[];
    included_tag_ids?: string[];
    ticket_scope?: "all" | "unassigned";
    started_at?: string;
  }) {
    return apiFetch<{ message?: string }>("/emergency/enable", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  emergencyUpdate(
    projectId: string,
    body: {
      message?: string;
      note?: string;
      thread_url?: string;
      excluded_tag_ids?: string[];
      included_tag_ids?: string[];
      ticket_scope?: "all" | "unassigned";
    },
  ) {
    return apiFetch<EmergencyModeWithStats>(
      `/emergency/active/${encodeURIComponent(projectId)}`,
      {
        method: "PATCH",
        body: JSON.stringify(body),
      },
    );
  },

  emergencyApplyUnassigned(projectId: string) {
    return apiFetch<{
      message?: string;
      result?: {
        tickets_total?: number;
        tickets_processed?: number;
        ticket_scope?: string;
      };
      emergency_mode?: EmergencyModeWithStats;
    }>(`/emergency/active/${encodeURIComponent(projectId)}/apply-unassigned`, {
      method: "POST",
    });
  },

  emergencyDisable(body: {
    project_id: string;
    completion_message: string;
    action: "resolve" | "close" | "open";
  }) {
    return apiFetch<{ message?: string }>("/emergency/disable", {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  emergencySendMessage(projectId: string, body: { message: string }) {
    return apiFetch<{
      message?: string;
      result?: { tickets_count: number; messages_sent: number };
    }>(`/emergency/active/${encodeURIComponent(projectId)}/send-message`, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  emergencyActiveWithStats() {
    return apiFetch<EmergencyModeWithStats[]>("/emergency/active-with-stats");
  },

  emergencyIncidentHistory(params: { limit: number; offset: number; emergency_mode_id?: number }) {
    const q = new URLSearchParams({ limit: String(params.limit), offset: String(params.offset) });
    if (params.emergency_mode_id != null) q.set("emergency_mode_id", String(params.emergency_mode_id));
    return apiFetch<EmergencyIncidentHistoryPage>(`/emergency/history/incidents?${q.toString()}`);
  },
  emergencyHistoryPage(params: { limit: number; offset: number; emergency_mode_id?: number }) {
    const q = new URLSearchParams();
    q.set("limit", String(params.limit));
    q.set("offset", String(params.offset));
    if (params.emergency_mode_id != null) q.set("emergency_mode_id", String(params.emergency_mode_id));
    return apiFetch<EmergencyModeHistoryPage>(`/emergency/history/page?${q.toString()}`);
  },
  emergencyHistory() {
    return apiFetch<EmergencyModeHistoryRow[]>("/emergency/history");
  },

  emergencyDisableStatus(projectId: string) {
    return apiFetch<EmergencyDisableStatus>(
      `/emergency/disable-status/${encodeURIComponent(projectId)}`,
    );
  },

  emergencyDisableResume(projectId: string) {
    return apiFetch<{ message?: string; result?: Record<string, unknown> }>(
      `/emergency/disable-resume/${encodeURIComponent(projectId)}`,
      { method: "POST" },
    );
  },

  activityLogs(params: {
    project_id?: string;
    ticket_id?: string;
    user_id?: string;
    activity_type?: string;
    entity_type?: string;
    search?: string;
    days?: number;
    date_time_from?: string;
    date_time_to?: string;
    limit?: number;
    offset?: number;
  }) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, String(v));
    }
    return apiFetch<ActivityLogListResponse>(`/activity-logs/?${q.toString()}`);
  },

  activityLogStats(days?: number) {
    const q = new URLSearchParams();
    if (days != null) q.set("days", String(days));
    const qs = q.toString();
    return apiFetch<ActivityLogStats>(
      `/activity-logs/stats${qs ? `?${qs}` : ""}`,
    );
  },

  activityLogTypes() {
    return apiFetch<string[]>("/activity-logs/types");
  },

  activityLogEntities() {
    return apiFetch<string[]>("/activity-logs/entities");
  },

  exportActivityLogs(params: {
    project_id?: string;
    ticket_id?: string;
    user_id?: string;
    activity_type?: string;
    entity_type?: string;
    search?: string;
    days?: number;
    date_time_from?: string;
    date_time_to?: string;
    format: "csv" | "json";
  }) {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, String(v));
    }
    return apiFetchBlob(`/activity-logs/export?${q.toString()}`);
  },

  projectActualizationAnalyze(projectId: string, body: { user_input: string }) {
    return apiFetch<Record<string, unknown>>(
      `/projects/${encodeURIComponent(projectId)}/ai/actualization/analyze`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  },

  projectActualizationApply(
    projectId: string,
    body: {
      apply_now: boolean;
      apply_at_utc: string | null;
      diff_package: Record<string, unknown>;
    },
  ) {
    return apiFetch<{ status?: string; job_id?: string; applied?: unknown }>(
      `/projects/${encodeURIComponent(projectId)}/ai/actualization/apply`,
      { method: "POST", body: JSON.stringify(body) },
    );
  },

  projectProductDocumentOpenAIModels(
    projectId: string,
    body: { openai_api_key: string },
  ) {
    return apiFetch<{
      models: {
        id: string;
        owned_by?: string | null;
        created?: number | null;
      }[];
    }>(
      `/projects/${encodeURIComponent(projectId)}/ai/product-document/openai-models`,
      { method: "POST", body: JSON.stringify(body) },
    );
  },

  projectProductDocumentGenerate(
    projectId: string,
    body: { openai_api_key: string; model: string; product_document: string },
  ) {
    return apiFetch<Record<string, unknown>>(
      `/projects/${encodeURIComponent(projectId)}/ai/product-document/generate`,
      { method: "POST", body: JSON.stringify(body) },
    );
  },

  projectProductDocumentApply(
    projectId: string,
    body: {
      apply_now: boolean;
      apply_at_utc: string | null;
      diff_package: Record<string, unknown>;
      project_ai_patch?: Record<string, unknown> | null;
      apply_mode?: "add" | "replace_all" | "no_materials";
    },
  ) {
    return apiFetch<{
      status?: string;
      applied?: unknown;
      variables_count?: number;
      system_prompt_updated?: boolean;
    }>(`/projects/${encodeURIComponent(projectId)}/ai/product-document/apply`, {
      method: "POST",
      body: JSON.stringify(body),
    });
  },

  projectTemporaryInstructionGenerate(
    projectId: string,
    body: { openai_api_key: string; model: string; source_text: string },
  ) {
    return apiFetch<Record<string, unknown>>(
      `/projects/${encodeURIComponent(projectId)}/ai/temporary-instructions/generate`,
      { method: "POST", body: JSON.stringify(body) },
    );
  },

  projectTemporaryInstructionSchedule(
    projectId: string,
    body: {
      title: string;
      start_at_utc: string;
      end_at_utc: string;
      instruction: Record<string, unknown>;
      kb_items: Record<string, unknown>[];
    },
  ) {
    return apiFetch<Record<string, unknown>>(
      `/projects/${encodeURIComponent(projectId)}/ai/temporary-instructions/schedule`,
      { method: "POST", body: JSON.stringify(body) },
    );
  },

  projectTemporaryInstructions(projectId: string) {
    return apiFetch<{ items: Record<string, unknown>[] }>(
      `/projects/${encodeURIComponent(projectId)}/ai/temporary-instructions`,
    );
  },

  updateProjectTemporaryInstruction(
    projectId: string,
    instructionId: string,
    body: {
      title?: string;
      start_at_utc?: string;
      end_at_utc?: string;
      instruction?: Record<string, unknown>;
      kb_items?: Record<string, unknown>[];
    },
  ) {
    return apiFetch<Record<string, unknown>>(
      `/projects/${encodeURIComponent(projectId)}/ai/temporary-instructions/${encodeURIComponent(instructionId)}`,
      { method: "PUT", body: JSON.stringify(body) },
    );
  },

  deleteProjectTemporaryInstruction(projectId: string, instructionId: string) {
    return apiFetch<Record<string, unknown>>(
      `/projects/${encodeURIComponent(projectId)}/ai/temporary-instructions/${encodeURIComponent(instructionId)}`,
      { method: "DELETE" },
    );
  },

  stopProjectTemporaryInstruction(projectId: string, instructionId: string) {
    return apiFetch<Record<string, unknown>>(
      `/projects/${encodeURIComponent(projectId)}/ai/temporary-instructions/${encodeURIComponent(instructionId)}/stop`,
      { method: "POST", body: "{}" },
    );
  },

  projectActualizationJobs(projectId: string) {
    return apiFetch<{
      items: {
        id: string;
        status: string;
        apply_at_utc: string | null;
        error: string | null;
        payload?: Record<string, unknown> | null;
        created_at: string;
        updated_at: string;
      }[];
    }>(`/projects/${encodeURIComponent(projectId)}/ai/actualization/jobs`);
  },

  aiAuditExportCsv(params: {
    days?: number;
    project_id?: string;
    user_id?: string;
    action_group?: string;
    search?: string;
    export_limit?: number;
  }) {
    const q = new URLSearchParams();
    q.set("format", "csv");
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === "") continue;
      q.set(k, String(v));
    }
    return apiFetchBlob(`/activity-logs/ai-audit/export?${q.toString()}`);
  },
};
